import https, { exportBaseURL } from './http'
import {bmsAsyncTask} from './../main.js'

/**
 * 异步导出任务走 exportBaseURL（生产 8080），其余走默认 baseURL
 * 调用处：post / get
 */
function buildRequestConfig(url, config) {
	config = config || {};
	if (url.startsWith(bmsAsyncTask)) {
		return { ...config, baseURL: exportBaseURL };
	}
	return config;
}

function post(url, data, config) {
	data = data || {};
	return new Promise((resolve, reject) => {
		https.post(url, data, buildRequestConfig(url, config))
			.then(res => {
				resolve(res)
			})
			.catch(err => {
				reject(err)
			})
	})
}
function get(url, data, config) {
	data = data || {};
	return new Promise((resolve, reject) => {
		https.get(url, { params: data, ...buildRequestConfig(url, config) })
			.then(res => {
				resolve(res);
			})
			.catch(err => {
				reject(err);
			})
	});
}

export default {
	getByUrl: (url) => { return get(url, null, null) },
	// 登录
	login: (params) => { return post('/login', params) },
	/** 嵌入入口消费 embedCode；调用方：views/embed/EmbedEntry.vue */
	embedConsume: (params) => { return post('/open/embed/consume', params) },
	//修改密码 检查原密码
	checkPwd: (params) => { return post('/checkPwd', params) },
	//修改密码 密码更新
	updatePwd: (params) => { return post('/updatePwd', params) },
	//根据用户id查询用户
	listUserByRoleId: (params) => { return post('/listUserByRoleId', params) },
	// 查询导出记录
	queryExcelImportExportHistory: (params) => { return post('/excelImportExportHistory/pageList', params) },
	//回款日报 查询
	queryReturnDailyReport: (params) => { return post('/returnedMoneyOrder/queryReturnDailyReport', params) },
	//回款日报 编辑
	editReturnDailyReport: (params) => { return post('/returnedMoneyOrder/editReturnDailyReport', params) },
	//登记回款 查询
	queryListPage: (params) => { return post('/returnedMoneyOrder/queryListPage', params) },
	//平台费预提 查询
	queryPlatformFeeAccrualListPage: (params) => { return post('/platform/fee/accrual/queryListPage', params) },
	//平台费预提 统计金额
	queryPlatformFeeAccrualTotalMoney: (params) => { return post('/platform/fee/accrual/totalMoney', params) },
	//平台费预提 导出
	exportPlatformFeeAccrual: (params) => { return post('/platform/fee/accrual/export', params) },
	//平台费预提 审核
	auditPlatformFeeAccrual: (params) => { return post('/platform/fee/accrual/audit', params) },
	//登记回款 支付方式
	queryPaymentTypeList: (params) => { return post('/returnedMoneyOrder/queryPaymentTypeList', params) },
	//撤销审核台账撤销人
	queryCancelAuditorList: (params) => { return post('/approval/queryCancelAuditorList', params) },
	//登记回款 修改
	update: (params) => { return post('/returnedMoneyOrder/update', params) },
	//登记回款 导入
	import: (params) => { return post('/returnedMoneyOrder/upload', params) },
	//登记回款 工行导入
	importByICBC: (params) => { return post('/returnedMoneyOrder/importByICBC', params) },
	//登记回款 删除
	deleteBatch: (params) => { return post('/returnedMoneyOrder/deleteBatch', params) },
	//登记回款 查询单个数据
	getById: (params) => { return post('/returnedMoneyOrder/getById', params) },
	//登记回款 导出
	exportRepaymentExcel: (params) => { return post(bmsAsyncTask + '/easyPoi/exportRepaymentExcel', params) },
	//登记回款 导出
	downloadRepaymentExcel: (params) => { return post('/easyPoi/downloadRepaymentExcel', params) },
	//登记回款 提交
	submitSettler: (params) => { return post('/returnedMoneyOrder/submitSettler', params) },
	//登记回款 提交-检查是否票据相关
	checkNoteType: (params) => { return post('/returnedMoneyOrder/checkNoteType', params) },
	//登记回款 获取发票信息 平台
	queryInvoicesForPlatform: (params) => { return post('/returnedMoneyOrder/queryInvoicesForPlatform', params) },
	//登记回款 获取发票信息 银行
	queryInvoicesForBank: (params) => { return post('/returnedMoneyOrder/queryInvoicesForBank', params) },
	//登记回款 查询详情
	getReturnedDetailForPlatform: (params) => { return post('/returnedMoneyOrder/getReturnedDetailForPlatform', params) },
	//登记回款 查询金额总计
	querySumBankOrPlat: (params) => { return post('/returnedMoneyOrder/querySumBankOrPlat', params) },
	//登记回款 全部提交
	submitSettlerByCondition: (params) => { return post('/returnedMoneyOrder/submitSettlerByCondition', params) },
	//回款确认 查询
	confirmQueryListPage: (params) => { return post('/confirm/queryListPage', params) },
	//回款确认 驳回 银行
	confirmReject: (params) => { return post('/confirm/reject', params) },
	//回款确认 提交 银行
	confirmSubmit: (params) => { return post('/confirm/submit', params) },
	//回款确认 编辑查询 平台
	confirmGetInvoice: (params) => { return post('/confirm/getInvoice', params) },
	//回款确认 查发票 平台
	confirmGetRetrunInvoice: (params) => { return post('/confirm/getRetrunInvoice', params) },
	//回款确认 查订单 平台
	confirmGetOrderByInvoice: (params) => { return post('/confirm/getOrderByInvoice', params) },
	//回款确认 查详情 平台
	confirmQueryInvoiceItemByReturn: (params) => { return post('/confirm/queryInvoiceItemByReturn', params) },
	//回款确认 匹配 验证
	warnMatchContinue: (params) => { return post('/returnedMoneyOrder/warnMatchContinue', params) },
	//回款确认 编辑 银行
	confirmEditForBank: (params) => { return post('/confirm/editForBank', params) },
	//回款台账与审批 查询 平台
	queryApprovalListPage: (params) => { return post('/approval/queryApprovalListPage', params) },
	//回款台账列表 查询
	queryAccountListPage: (params) => { return post('/approval/queryAccountListPage', params) },
	//回款台账 查询
	queryListPageForBill: (params) => { return post('/approval/queryListPageForBill', params) },
	//回款台账 详情
	queryDetailForBank: (params) => { return post('/approval/queryDetailForBank', params) },
	//回款台账 详情
	addBussinessremark: (params) => { return post('/approval/addBussinessremark', params) },
	//回款确认 详情
	queryDetailForBill: (params) => { return post('/approval/queryDetailForBill', params) },
	//回款确认 查订单 银行
	confirmQueryDetailForBank: (params) => { return post('/confirm/queryDetailForBank', params) },
	//回款确认 查发票 银行
	confirmQueryInvoicesForBank:(params) =>{return post('/confirm/queryInvoicesForBank',params)},
	//回款确认 历史匹配抬头
	confirmQueryCustRefList: (params) => { return post('/confirm/queryCustRefList', params) },
	resetMatch:(params) =>{return post('/confirm/resetMatch',params)},
	//回款确认 编辑确定 银行
	confirmConfirm: (params) => { return post('/confirm/confirm', params) },
	//回款确认 结算员列表
	confirmQuerySettler: (params) => { return post('/confirm/querySettler', params) },
	//回款确认 编辑取消
	confirmUnlock: (params) => { return post('/confirm/unlock', params) },
	//回款确认 导入 银行
	confirmImportMatchRecords: (params) => { return post('/confirm/importMatchRecords', params) },
	//回款确认 结算员列表 确定
	confirmTransfer: (params) => { return post('/confirm/transfer', params) },
	//回款台账与审批 表明细
	queryApprovalDetail: (params) => { return post('/approval/queryApprovalDetail', params) },
	//回款台账与审批 审核同意
	agreeAuditReturned: (params) => { return post('/approval/agreeAuditReturned', params) },
	//回款台账与审批 驳回审核
	rejectAuditReturned: (params) => { return post('/approval/rejectAuditReturned', params) },
	//回款台账 撤销
	repealMoneyOrder: (params) => { return post('/approval/repealMoneyOrder', params) },
	//回款台账 回款录入员撤销
	repealToRegister:(params) =>{return post('/approval/repealToRegister',params)},

	queryTopNavList:(params) =>{return post('/reqorder/queryTopNavList',params)},
	//回款台账 查询回款台账总额
	querySumBankOrPlatBill: (params) => { return post('/returnedMoneyOrder/querySumBankOrPlatBill', params) },
	//回款审批账 查询回款台账总额
	querySumBankOrPlatAudit: (params) => { return post('/returnedMoneyOrder/querySumBankOrPlatAudit', params) },
	//回款台账与审批 提交SPA凭证
	getManualVoucher: (params) => { return post('/approval/getManualVoucher', params) },
	//回款台账 取消SPA凭证
	cancelManualVoucher: (params) => { return post('/approval/cancelManualVoucher', params) },
	//回款台账 撤销审核
	cancelAudit: (params) => { return post('/approval/cancelAudit', params) },
	//回款台账 凭证添加
	addReturnVoucher: (params) => { return post('/returnedMoneyOrder/addReturnVoucher', params) },
	//回款台账 发起退款
	customerRefundAdd: (params) => { return post('/customerRefund/add', params) },
	//客户退款 退款财务确认
	customerRefundContirm: (params) => { return post('/customerRefund/confirm', params) },
	//客户退款 退款财务驳回
	customerRefundReject: (params) => { return post('/customerRefund/reject', params) },
	//回款台账与审批 补发回款信息
	sendPassMq: (params) => { return post('/approval/sendPassMq', params) },
	//发票调账 查询
	invoiceChangeQueryListPage: (params) => { return post('/invoiceChange/queryListPage', params) },
	//发票调账 导出
	changeAmountImport: (params) => { return post('/invoiceChange/changeAmountImport', params) },
	//发票调账 调账
	changeAmountQuick: (params) => { return post('/invoiceChange/changeAmountQuick', params) },
	//发票调账 查询总计金额
	querySumPrice: (params) => { return post('/invoiceChange/querySumPrice', params) },
	//发票台账 查询
	invoiceQueryListInvoicePage: (params) => { return post('/invoice/queryListInvoicePage', params) },
	// 合约集采项目下拉（invoice.contract_project / zrsv02 去重）；调用处：invoiceDetail.vue#loadContractProjectApiOptions
	listContractProjectApiOptions: (params) => { return post('/invoice/listContractProjectApiOptions', params) },
	//发票台账 查询详情
	invoiceQueryInvoiceMatchReturnedDetail: (params) => { return post('/invoice/qryDetailForPlateReMatch', params) },
	pageInvMatchDetail: (params) => { return post('/invoice/pageInvMatchDetail', params) },
	pageSapMatchDetail: (params) => { return post('/invoice/pageSapMatchDetail', params) },
	//发票台账 查询 发票明细
	queryInvoiceItems: (params) => { return post('/invoice/queryInvoiceItems', params) },
	//发票台账 查询 凭证明细
	queryVoucherItems: (params) => { return post('/invoice/queryVoucherItems', params) },
	//发票台账 导入
	importInvoices: (params) => { return post('/invoice/importInvoices', params) },
	//发票台账 发票初始化
	resetInvoice: (params) => { return post('/invoice/resetInvoice', params) },
	//更新金税发票
	updateInvoice: (params) => { return post('/invoice/updateInvoice', params) },
	//维护金税发票回款状态
	maintainInvoiceReturnStatus: (params) => { return post('/invoice/maintainInvoiceReturnStatus', params) },
	//发票台账 变更确认人
	transferToOther: (params) => { return post('/invoice/transferToOther', params) },
	//发票台账 重新获取发票明细
	getInvoiceDetail: (params) => { return post('/invoice/getDetail', params) },
	//发票台账 重新获取发票明细
	downloadTheEreceipt: (params) => { return post('/invoice/downloadTheEreceipt', params) },
	// 历史发货单 查询
	historyBillList: (params) => { return post('/historyBill/list', params) },
	// POS机维护 查询
	posQueryListPage: (params) => { return post('/pos/queryListPage', params) },
	// POS机维护 新增
	addPosInfo: (params) => { return post('/pos/addPosInfo', params) },
	// POS机维护 修改
	updatePosInfo: (params) => { return post('/pos/updatePosInfo', params) },
	// POS机维护 删除
	deletePosInfo: (params) => { return post('/pos/deletePosInfo', params) },
	// 不知名回款 查询列表
	qureyUnnamedList: (params) => { return post('/unnamed/qureyUnnamedList', params) },
	// 不知名回款 查询详情
	qureyUnnamedMatchRecords: (params) => { return post('/unnamed/qureyUnnamedMatchRecords', params) },
	// 不知名回款 审核-查询列表
	qureyUnnamedMatchRecordsPage: (params) => { return post('/unnamed/qureyUnnamedMatchRecordsPage', params) },
	// 不知名回款 审核
	unnamedApproval: (params) => { return post('/unnamed/approval', params) },
	// 不知名回款 SP供应商推送列表查询
	qureyUnnamedSuppliers: (params) => { return post('/unnamed/qureyUnnamedSuppliers', params) },
	// 不知名回款 SP供应商推送
	pushUnnamedSupplierRel: (params) => { return post('/unnamed/pushUnnamedSupplierRel', params) },
	// 不知名回款 导入
	importUnnamedSupplierRel: (params) => { return post('/unnamed/importUnnamedSupplierRel', params) },
	// 不知名回款 省份
	querySearchCondition: (params) => { return post('/unnamed/querySearchCondition', params) },
	// 不知名回款 推送-获取合约集采项目
	queryProjectsFromContracts: (params) => { return post('/unnamed/queryProjectsFromContracts', params) },
	// 不知名回款 推送-查询集采项目合作的SP供应商
	queryServicerByProject: (params) => { return post('/unnamed/queryServicerByProject', params) },
	// 不知名回款 推送-查询省份
	queryServicerByProvince: (params) => { return post('/base/queryProvince', params) },
	// 不知名回款 推送-查询SP供应商
	queryServiceList: (params) => { return post('/unnamed/queryServiceList', params) },
	// 英大回款 查询
	yingdaMatchQueryListPage: (params) => { return post('/yingdaMatch/queryListPage', params) },
	// 英大回款 导入
	yingdaMatchUpload: (params) => { return post('/yingdaMatch/upload', params) },
	//英大回款 导出
	yingdaMatchExportSelective: (params, config) => { return post(bmsAsyncTask + '/yingdaMatch/exportSelective', params, config) },
	// 撤销审核台账 查询
	queryCancelAuditListPage: (params) => { return post('/approval/queryCancelAuditListPage', params) },
	// 撤销审核台账 导出
	exportCancelAudit: (params, config) => { return post(bmsAsyncTask + '/approval/exportCancelAudit', params, config) },
	// 采购单台账 导出
	purchaseExportExcel: (params, config) => { return post(bmsAsyncTask + '/reqorder/purchase/exportBMSExcel', params, config) },
	//上传文件到指定文件夹
	uploadFileToDirectory:(params) => { return post('/reqorder/upload/file', params) },
	//上传文件到oss
	uploadFile:(params) => { return post('/reqorder/upload', params) },
	// 四角订单台账 导出
	purchaseExportSpecialExcel: (params, config) => { return post(bmsAsyncTask + '/reqorder/purchase/exportSpecialExcel', params, config) },
	//发票台账 导出
	exportInvoiceDetail: (params, config) => { return post(bmsAsyncTask + '/easyPoi/exportInvoiceDetail', params, config) },
	// 分销回款-列表查询
	drQueryListPage: (params) => { return post('/distributionRepayment/queryListPage', params) },
	// 分销回款-银行/平台列表
	drQueryAllByReturnedPaymentConfig: (params) => { return post('/distributionRepayment/queryAllByReturnedPaymentConfig?companyCode=1100', params) },
	// 分销回款-客户列表
	drQueryCustomerList: (params) => { return post('/distributionRepayment/queryCustomerList', params) },
	// 分销回款 导出
	drExport: (params, config) => { return post(bmsAsyncTask + '/distributionRepayment/export', params, config) },
	// 分销回款-确认
	drAudit: (params) => { return post('/distributionRepayment/audit', params) },
	// 分销回款-新增客户
	addCustomer: (params) => { return post('/distributionRepayment/addCustomer', params) },
	// 分销回款-退回GS
	drBackGS: (params) => { return post('/distributionRepayment/backGS', params) },
	// 分销回款-获取凭证信息
	drGetVoucher: (params) => { return post('/distributionRepayment/getVoucher', params) },
	// 分销回款-生成凭证
	drProductVoucher: (params) => { return post('/distributionRepayment/productVoucher', params) },
	// 分销回款-生成凭证
	drBatchProductVoucher: (params) => { return post('/distributionRepayment/batchProductVoucher', params) },
	// 分销回款-冲销凭证
	drCoverVoucher: (params) => { return post('/distributionRepayment/coverVoucher', params) },
	// 分销回款-变更客编
	drAdjustingCustomerEditors: (params) => { return post('/distributionRepayment/adjustingCustomerEditors', params) },
	// 分销回款-操作日志
	drOperateLog: (params) => { return post('/distributionRepayment/operateLog', params) },
	// 国际回款-列表查询
	irPageList: (params) => { return post('/internationalRepayment/pageList', params) },
	// 国际回款-银行/平台列表
	irPlatforms: (params) => { return post('/internationalRepayment/platforms', params) },
	// 国际回款 导出
	irExport: (params, config) => { return post(bmsAsyncTask + '/internationalRepayment/export', params, config) },
	// 国际回款-入账客户
	irCustomers: (params) => { return post('/internationalRepayment/customers', params) },
	// 国际回款-新增客户
	irAddCustomer: (params) => { return post('/internationalRepayment/addCustomer', params) },
	// 国际回款-确认
	irConfirm: (params) => { return post('/internationalRepayment/confirm', params) },
	// 国际回款-调整客编
	irAdjustingCustomerEditors: (params) => { return post('/internationalRepayment/adjustingCustomerEditors', params) },
	// 国际回款-退回GS
	irBackGS: (params) => { return post('/internationalRepayment/backGS', params) },
	// 国际回款-审核
	irAudit: (params) => { return post('/internationalRepayment/audit', params) },
	// 国际回款-获取凭证信息
	irGetVoucher: (params) => { return post('/internationalRepayment/getVoucher', params) },
	// 国际回款-生成凭证
	irProductVoucher: (params) => { return post('/internationalRepayment/productVoucher', params) },
	// 国际回款-冲销凭证
	irCoverVoucher: (params) => { return post('/internationalRepayment/coverVoucher', params) },
	// 客户退款-列表查询
	customerRefundQueryPage: (params) => { return post('/customerRefund/queryListPage', params) },
	// 客户退款-列表导出
	customerRefundExport: (params) => { return post(bmsAsyncTask + '/customerRefund/export', params) },
	// 票据管理-列表
	returnedMoneyNotePageListNote: (params) => { return post('/returnedMoneyNote/pageListNote', params) },
	// 票据管理-导入
	importNoteFile: (params) => { return post('/returnedMoneyNote/importNoteFile', params) },
	//票据管理-导出
	returnedMoneyNoteExportExcel: (params) => { return post(bmsAsyncTask + '/returnedMoneyNote/exportExcel', params) },
	// 票据管理-删除
	deleteByNoteIds: (params) => { return post('/returnedMoneyNote/deleteByNoteIds', params) },
	// 票据管理-拉取信用票据接口
	pullOACreditNoteData: (params) => { return post('/returnedMoneyNote/pullOACreditNoteData', params) },
	// 票据管理-拉取债券票据接口
	pullOABondNoteData: (params) => { return post('/returnedMoneyNote/pullOABondNoteData', params) },
	listBondProductPlatformOptions: () => { return get('/returnedMoneyNote/listBondProductPlatformOptions') },
	// 债权凭证-产品配置列表
	listBondProductPlatformConfig: () => { return get('/returnedMoneyNote/listBondProductPlatformConfig') },
	// 债权凭证-保存产品配置
	saveBondProductPlatformConfig: (params) => { return post('/returnedMoneyNote/saveBondProductPlatformConfig', params) },
	// 债权凭证-下载导入模板（产品名称页为最新配置）
	downloadBondImportTemplate: () => { return get('/returnedMoneyNote/downloadBondImportTemplate', {}, { responseType: 'blob' }) },
	// 票据管理-获取票据回款详情
	listReturnMoneyOrderByNoteNumber: (params) => { return get('/returnedMoneyNote/listReturnMoneyOrderByNoteNumber', params) },
	// 票据管理-查询日志记录
	logQueryListPage: (refCode, params) => { return post('/log/operate/queryListPage/'+refCode, params) },
	// 票据管理-获取票据详情
	getNoteDetailByNoteNumber: (params) => { return get('/returnedMoneyNote/getNoteDetailByNoteNumber', params) },
	// 票据管理-接收账号
	rmnQueryAllByReturnedPaymentConfig: (companyCode) => { return post('/distributionRepayment/queryAllByReturnedPaymentConfig?companyCode='+companyCode) },
	// 票据管理-上传文件
	ossLoadFile: (params) => { return post('/oss/loadFile', params) },
	// 票据管理-更新票据
	updateNoteByNoteId: (params) => { return post('/returnedMoneyNote/updateNoteByNoteId', params) },
	// 票据管理-提交oa
	batchCommitOA: (params) => { return post('/returnedMoneyNote/batchCommitOA', params) },
	// 票据管理-获取票据可兑现的回款单
	getNoteOrderByReturnMoneyNo: (params) => { return get('/returnedMoneyOrder/getNoteOrderByReturnMoneyNo', params) },
	// 票据管理-兑现
	returnedMoneyNoteCash: (params) => { return post('/returnedMoneyNote/cash/manual', params) },
	queryRetunedLogList: (params) => { return post('/log/operate/queryRetunedLogList/'+params) },


	/**
	* @api 齐心1.5期
	*/

	//供应商额度管理 查询
	queryPlatformMountListPage: (params) => { return post('/platformamount/queryListPage', params) },
	//供应商额度管理 额度调整
	queryPlatformMountChange: (params) => { return post('/platformamount/amountChange', params) },
	//供应商额度管理 额度变更历史查询
	queryPlatformMountChangeLog: (params) => { return post('/platformamount/queryChangeLog', params) },
	//基础数据维护-》供应商额度
	queryLatestSixMonthsPlatformHistoryRecord: (params) => { return post('/platform/queryLatestSixMonthsPlatformHistoryRecord', params) },
	//SP供应商发票确认 查询
	qureyBuyinvoiceList: (params,config) => { return post('/buyinvoice/qureyBuyinvoiceList', params,config) },
	//SP供应商发票确认 查询详情
	getBuyinvoiceDetails: (params) => { return post('/buyinvoice/getBuyinvoiceDetails', params) },
	//SP供应商发票确认 驳回
	updateBuyinvoiceStatusListReject: (params) => { return post('/buyinvoice/updateBuyinvoiceStatusListReject', params) },
	//SP供应商发票确认 存量单据解禁
	unlockGroupNumber: (params) => { return post('/buyinvoice/unlockGroupNumber', params) },
	//SP供应商发票确认 通知入库
	storagePurchaseOrder: (params) => { return post('/buyinvoice/storagePurchaseOrder', params) },
	//SP供应商发票确认 审核通过
	updateBuyinvoice: (params) => { return post('/buyinvoice/updateBuyinvoice', params) },
	//SP供应商发票确认 合计价税和未税
	qureyBuyinvoiceTotalMoney: (params) => { return post('/buyinvoice/qureyBuyinvoiceTotalMoney', params) },
	//SP供应商发票确认 查询发票供应商信息
	queryBuyinvoicePlatformInfo: (params) => { return post('/buyinvoice/queryBuyinvoicePlatformInfo', params) },
	//SP供应商发票驳回 检查请款状态
	listByBuyinvoiceIds: (params) => { return post('/reqorder/financialaudit/listByBuyinvoiceIds', params) },
	//SP供应商发票确认 查询发票供应商信息
	queryBuyinvoicePlatformInfoForSpecial: (params) => { return post('/buyinvoice/queryBuyinvoicePlatformInfoForSpecial', params) },
	//SP供应商发票台账 查询
	serviceGetProviderServe: (params) => { return post('/purchaseorder/getProviderServe', params) },

	//SP供应商发票台账 供应商发票台账  进项发票台账 查询
	// serviceGetProvider:(params) =>{return post('/purchaseorder/getProvider',params)},

	//SP供应商发票台账  撤回
	BMSrecallPurchaseOrderByIds: (params) => { return post('/purchaseorder/BMSrecallPurchaseOrderByIds', params) },
	//SP供应商发票台账 查询详情
	serviceGetBuyinvoiceDetails: (params) => { return post('/buyinvoice/getBuyinvoiceDetails', params) },
	//SP供应商发票台账 修改备注
	serviceUpdateRemark: (params) => { return post('/buyinvoice/updateRemark', params) },
	// SP供应商发票台账 合计价税和未税
	getProviderServeTotalMoney: (params) => { return post('/purchaseorder/getProviderServeTotalMoney', params) },
	// SP供应商发票台账 复制关联采购单号
	copyProviderPurchaseNos: (params) => { return post('/purchaseorder/getProviderPurchaseNos', params) },
	//供应商发票登记 查询
	queryPurchaseorderList: (params) => { return post('/purchaseorder/queryPurchaseorderList', params) },
	//供应商发票登记 查看采购单明细
	platformGetPurchaseOrderDetail: (params) => { return post('/purchaseorder/getPurchaseOrderDetail', params) },
	//供应商发票登记 批量发票登记-提交
	saveBuyinvoicePlatform: (params) => { return post('/buyinvoice/saveBuyinvoicePlatform', params) },
	//供应商发票登记 快递查询
	queryExpressList: (params) => { return post('/base/queryExpressList', params) },
	//拦截对被锁定的采购单的操作
	intercepteForLockedPurchaseOrder: (params) => { return post('/purchaseorder/intercepteForLockedPurchaseOrder', params) },
	//采购订单解锁上锁功能
	unlockPurchaseOrder: (params) => { return post('/purchaseorder/unlockPurchaseOrder', params) },
	//大贲锁定/解锁接口
	acmeLockUnlock: (params) => { return post('/purchaseorder/acmeLockUnlock', params) },
	//查询采购单跟进记录
	getPurchaseOrderFollowRecords: (params) => { return post('/purchaseorder/followRecords', params) },
	//提交采购单跟进记录
	addPurchaseOrderFollow: (params) => { return post('/purchaseorder/follow', params) },
	//供应商发票登记 批量登记发票采购单查看明细
	platformGetPurchaseOrderByIdsList: (params) => { return post('/purchaseorder/getPurchaseOrderByIdsList', params) },
	// 供应商发票登记 合计价税和未税
	queryPurchaseorderListTotalMoney: (params) => { return post('/purchaseorder/queryPurchaseorderListTotalMoney', params) },
	//供应商发票台账 查询
	getProviderPlatform: (params) => { return post('/purchaseorder/getProviderPlatform', params) },
	//供应商发票台账  撤回
	BMSrecallPlatformByIdsBMS: (params) => { return post('/purchaseorder/BMSrecallPlatformByIds', params) },
	//供应商发票台账  合计价税和未税
	getProviderPlatformTotalMoney: (params) => { return post('/purchaseorder/getProviderPlatformTotalMoney', params) },
	//供应商订单台账 查询
	queryPurchaseOrder: (params) => { return post('/purchaseorder/queryPurchaseOrder', params) },
	//供应商订单台账 合计价税和未税
	queryPurchaseOrderTotalMoney: (params) => { return post('/purchaseorder/queryPurchaseOrderTotalMoney', params) },
	// 获取匹配记录
	getMatchResult: (id) => { return post('/buyinvoice/getMatchResult?groupNumber='+id) },
	// srm获取匹配记录
	srmGetMatchResult: (id) => { return post('/srmBillAuditInfo/getMatchResult?statementNo='+id) },
	// 异常上报
	matchTaskProblemReport: (params) => { return post('/matchTaskProblemReport/report', params) },
	// 查询日志记录
	getLogOperate: (refCode, params) => { return post('/log/operate/queryListPage/'+refCode, params) },
	// 查询是否有匹配相关权限
	checkMatchEnable: () => { return get('/buyinvoice/checkMatchEnable') },
	// 根据对账单号获取请款列表
	listSrmPayByStatementNo: (params,config) => { return post('/srmBillAuditInfo/listSrmPayByStatementNo', params,config) },
	// 查询退单匹配
	queryListCancelOrderMatchPage: (params) => { return post('/matchTaskRecord/queryListCancelOrderMatchPage', params) },
	// 查询匹配信息
	getMatchInfo: (params,config) => { return post('/matchTaskRecord/getMatchInfo', params,config) },
	// 查询匹配成功的记录
	queryListMatchSucRecord: (params,config) => { return post('/matchTaskRecord/queryListMatchSucRecord', params,config) },
	// 查询匹配失败的发票记录
	queryListMatchFailInvRecord: (params,config) => { return post('/matchTaskRecord/queryListMatchFailInvRecord', params,config) },
	// 查询匹配失败的订单记录
	queryListMatchFailOrderRecord: (params,config) => { return post('/matchTaskRecord/queryListMatchFailOrderRecord', params,config) },
	// 人工匹配
	matchTaskRecordManual: (params,config) => { return post('/matchTaskRecord/manualMatch', params,config) },
	/**
	* 多级供应商项目>>供应商业务
	*/
	//供应商查询-查询列表
	queryPlatformInfos: (params) => { return post('/platform/queryPlatformInfos', params) },
	//供应商查询-新增供应商
	savePlatformInfo: (params) => { return post('/platform/savePlatformInfo', params) },
	//供应商查询-编辑供应商
	updatePlatformInfo: (params) => { return post('/platform/updatePlatformInfo', params) },
	//供应商查询-额度维护
	updatePlatformLimitInfo: (params) => { return post('/platform/updatePlatformLimitInfo', params) },
	//供应商查询-供应商排序-查询列表
	queryPlatformInfoSortList: (params) => { return post('/platform/queryPlatformInfoSortList', params) },
	//供应商查询-供应商排序-批量修改排序
	updatePlatformInfoSort: (params) => { return post('/platform/updatePlatformInfoSort', params) },
	//供应商查询-额度明细
	queryPlatformLimitInfos: (params) => { return post('/platform/queryPlatformLimitInfos', params) },
	//供应商查询-导出
	exportPlatformInfos: (params) => { return get(bmsAsyncTask + '/easyPoi/exportPlatformInfos', params, { responseType: "blob" }) },
	//订单确认-查询列表
	getPurchaseOrdersToConfirm: (params) => { return post('/purchaseorder/getPurchaseOrdersToConfirm', params) },
	//订单确认-确认
	purchaseOrderConfirmInvoice: (params) => { return post('/buyinvoice/purchaseOrderConfirmInvoice', params) },
	//订单确认-驳回
	purchaseOrderRejectInvoice: (params) => { return post('/purchaseorder/purchaseOrderRejectInvoice', params) },
	//订单确认-导出
	exportPurchaseOrdersToConfirm: (params) => { return post(bmsAsyncTask + '/easyPoi/exportPurchaseOrdersToConfirm', params, { responseType: "blob" }) },
	//登记发票-查询列表
	getPurchaseOrdersToRegister: (params) => { return post('/purchaseorder/getPurchaseOrdersToRegister', params) },
	//登记发票-登记发票功能-校验此组是否已经登记
	checkBuyinvoiceGroupState: (params) => { return post('/buyinvoice/checkBuyinvoiceGroupState', params) },
	//登记发票-登记发票功能-根据发票组号进行登记
	getPurchaseOrderByGroupNumbers: (params) => { return post('/purchaseorder/getPurchaseOrderByGroupNumbers', params) },
	//登记发票-驳回
	rejectPurchaseOrderConfirmedInvoice: (params) => { return post('/purchaseorder/rejectPurchaseOrderConfirmedInvoice', params) },
	//发票台账-重新匹配
	reMatch: (params) => { return post('/purchaseorder/reMatch', params) },

	//登记发票-导出（进项发票终审导出-异步）
	exportPurchaseOrdersToRegisterList: (params) => { return post(bmsAsyncTask + '/easyPoi/exportPurchaseOrdersToRegisterList', params) },
	//发票台账-查询列表
	qureyPlatformBuyinvoiceList: (params) => { return post('/buyinvoice/qureyPlatformBuyinvoiceList', params) },
	//发票台账-导出
	exportPlatformBuyinvoiceList: (params) => { return post(bmsAsyncTask + '/easyPoi/exportPlatformBuyinvoiceList', params, { responseType: "blob" }) },
	//登记发票/发票台账-未登记发票的购买方/购买方/销售方
	qureyBuyinvoiceCompanyInfo: (params) => { return post('/buyinvoice/qureyBuyinvoiceCompanyInfo', params) },
	//订单确认/登记发票/发票台账-获取发票详情
	getBuyinvoiceDetailsByPurchaseId: (params) => { return post('/buyinvoice/getBuyinvoiceDetailsByPurchaseId', params) },

	qureyNoContractPlatformBuyinvoiceGroup: (params) => { return post('/platformContract/qureyNoContractPlatformBuyinvoiceGroup', params) },
	qureyPlatformContract: (params) => { return post('/platformContract/qureyPlatformContract', params) },
	generateContract: (params) => { return post('/platformContract/generateContract', params) },
	generateContractInfo: (params) => { return post('/platformContract/generateContractInfo', params) },
	savePaperContract: (params) => { return post('/platformContract/savePaperContract', params) },
	pushPlatformContract: (params) => { return post('/platformContract/pushPlatformContract', params) },
	platformRevertContract: (params) => { return post('/platformContract/revertContract', params) },
	//供应商合同-导出
	exportPlatformContractList: (params,config) => { return post(bmsAsyncTask + '/easyPoi/exportPlatformContractList', params, config) },
	/**
	* 进项发票管理
	*/
	//结算发起-商务 查询
	queryPurchaseorderListBusiness: (params) => { return post('/purchaseorder/queryPurchaseorderListBusiness', params) },
	//结算发起-商务 查看详情
	getPurchaseOrderDetail: (params) => { return post('/purchaseorder/getPurchaseOrderDetail', params) },
	//结算发起-商务 发起结算
	getPurchaseLaunchSettle: (params) => { return post('/purchaseorder/launchSettle', params) },
	//结算发起-商务 我已确认
	updatePurchaseOrderConfirmSettle: (params) => { return post('/purchaseorder/confirmSettle', params) },
	//结算发起-商务 取消发起
	getPurchaseOrderCancelSettle: (params) => { return post('/purchaseorder/cancelSettle', params) },
	//结算发起-商务 通知开票
	getPurchaseOrderQueryListAssignPlatform: (params) => { return post('/platform/queryListAssignPlatform', params) },
	//结算发起-商务 通知开票确定
	updatePurchaseOrderByPlatformCodeAssign: (params) => { return post('/purchaseorder/updatePurchaseOrderByPlatformCodeAssign', params) },
	//结算发起-商务 取消通知开票
	cancelInvoiceNotice: (params) => { return post('/purchaseorder/cancelInvoiceNotice', params) },
	//结算发起-商务 合计价税和未税
	queryPurchaseorderListBusinessTotalMoney: (params) => { return post('/purchaseorder/queryPurchaseorderListBusinessTotalMoney', params) },
	//结算发起-商务 特批
	specialOffer: (params) => { return post('/purchaseorder/specialOffer', params) },
	//结算发起-商务 取消特批
	cancelSpecialOffer: (params) => { return post('/purchaseorder/cancelSpecialOffer', params) },
	//结算发起-商务 成品油
	setPetroleumProduct: (params) => { return post('/purchaseorder/setPetroleumProduct', params) },
	//结算发起-商务 取消成品油
	cancelPetroleumProduct: (params) => { return post('/purchaseorder/cancelPetroleumProduct', params) },
	//进项发票确认-商务 查询
	queryInvoicesForConfirm: (params) => { return post('/buyinvoice/queryInvoicesForConfirm', params) },
	//进项发票确认-商务 确认
	agreeInvoiceC: (params) => { return post('/buyinvoice/agreeInvoiceC', params) },
	checkAgreeInvoiceCWarning: (params) => { return post('/buyinvoice/checkAgreeInvoiceCWarning', params) },
	// 商务确认前校验采购单签收是否完成
	checkAgreeInvoiceCDeliveryReceipt: (params) => { return post('/buyinvoice/checkAgreeInvoiceCDeliveryReceipt', params) },
	//进项发票确认-商务 合计价税和未税
	queryInvoicesForConfirmTotalMoney: (params) => { return post('/buyinvoice/queryInvoicesForConfirmTotalMoney', params) },
	//进项发票确认-商务 驳回
	rejectInvoiceC: (params) => { return post('/buyinvoice/rejectInvoiceC', params) },
	//进项发票确认-商务 编辑
	editBuyinvoiceInfo: (params) => { return post('/buyinvoice/editBuyinvoiceDetail', params) },
	getEditInvoiceExpectedParty: (params) => { return post('/buyinvoice/getEditInvoiceExpectedParty', params) },
	//进项发票确认-商务 带发票文件编辑
	editBuyinvoiceWithFile: (params) => { return post('/buyinvoice/editBuyinvoiceWithFile', params) },
	//进项发票 ocr
	buyInvoiceOcr: (params) => { return post('/buyinvoice/ocr', params) },
	//进项发票 ocr（按 onlyOcrFirst 控制是否仅识别首页，0多页 1仅首页）
	buyInvoiceOcrWithOption: (params) => { return post('/buyinvoice/ocrWithOption', params) },
	//进项发票审核-财务 查询
	qureyBuyinvoiceFinanceList: (params,config) => { return post('/buyinvoice/qureyBuyinvoiceFinanceList', params,config) },
	//进项发票审核-财务 同意
	updateBuyinvoiceFinanceListStatus: (params) => { return post('/buyinvoice/updateBuyinvoiceFinanceListStatus', params) },
	//进项发票审核-财务 驳回
	updateBuyinvoiceFinanceListStatusReject: (params) => { return post('/buyinvoice/updateBuyinvoiceFinanceListStatusReject', params) },
	//进项发票审核-财务 查看详情
	getFinanceBuyinvoiceDetails: (params) => { return post('/buyinvoice/getBuyinvoiceDetails', params) },
	//进项发票审核-财务 合计价税和未税
	qureyBuyinvoiceFinanceListTotalMoney: (params) => { return post('/buyinvoice/qureyBuyinvoiceFinanceListTotalMoney', params) },
	//进项发票台账 查询
	getComixInvoiceBill: (params) => { return post('/purchaseorder/getComixInvoiceBill', params) },
	//进项发票台账  撤回
	BMSrecallFinanceByIds: (params) => { return post('/purchaseorder/BMSrecallFinanceByIds', params) },
	//进项发票台账 提交sap凭证查询
	getReVoucher: (params) => { return post('/buyinvoice/getReVoucher', params) },
	//进项发票台账 提交sap凭证
	submitReVoucher: (params) => { return post('/buyinvoice/submitReVoucher', params) },
	// 发票校验-检查是否已生成红字SA凭证（独立接口，isc红字流程）
	checkRedInvoiceSaVoucher: (params) => { return post('/isc/redinvoice/checkRedInvoiceSaVoucher', params) },
	// 冲销红字流程SA凭证（独立接口，isc红字流程）
	cancelRedInvoiceSa: (params) => { return post('/isc/redinvoice/cancelRedInvoiceSa', params) },
	//进项发票台账 吊销sap凭证
	cancelReVoucher: (params) => { return post('/buyinvoice/cancelReVoucher', params) },
	//进项发票台账 吊销sap凭证前校验
	checkPostingDate: (params) => { return post('/buyinvoice/checkPostingDate', params) },
	//进项发票台账 导出sap凭证
	exportReVoucher: (params, config) => { return post(bmsAsyncTask + '/easyPoi/exportReVoucher', params, config) },
	//进项发票台账 合计价税和未税
	getComixInvoiceBillTotalMoney: (params) => { return post('/purchaseorder/getComixInvoiceBillTotalMoney', params) },
	//进项发票台账 更新抵扣状态（单个）
	updateInvoiceDeductionStatus: (params) => { return post('/buyinvoice/updateInvoiceDeductionStatus', params) },
	//进项发票台账 批量更新抵扣状态
	batchUpdateInvoiceDeductionStatus: (params) => { return post('/buyinvoice/batchUpdateInvoiceDeductionStatus', params) },
	//采购单台账 查询
	listFinance: (params) => { return post('/purchaseorder/listFinance', params) },
	//采购单台账 查看
	purchaseGetOrderDetails: (params) => { return post('/buyinvoice/getOrderDetails', params) },
	//采购单台账 查看
	purchaseItems: (params) => { return post('/buyinvoice/purchaseItems', params) },
	//采购单台账 批量发票导入
	purchaseImportBuyinvoice: (params) => { return post('/buyinvoice/importBuyinvoice', params) },
	//采购单台账 批量发票导入
	listFinanceTotalMoney: (params) => { return post('/purchaseorder/listFinanceTotalMoney', params) },
	//采购单台账 导入更改采购单状态
	importOrderStatus: (params) => { return post('/purchaseorder/importOrderStatus', params) },
	//采购单台账 更换采购订单
	changePurchaseOrder: (params) => { return post('/purchaseorder/changePurchaseOrder', params) },
	//红字发票台账 查询
	getRedinvoiceList: (params) => { return post('/redinvoice/qureyRedinvoiceNoticeList', params) },
	//红字发票台账 上传退货证明
	uploadReturnProve: (params) => { return post('/redinvoice/uploadReturnProve', params) },
	//红字发票台账 导入
	importRedInvoiceAccount: (params) => { return post('/redinvoice/importRedinvoiceNotice', params) },
	//红字发票台账 获取明细
	qureyRedinvoiceNoticeDetail: (params) => { return post('/redinvoice/qureyRedinvoiceNoticeDetail', params) },
	//红字发票台账 确认明细
	confirmRedinvoiceNotice: (params) => { return post('/redinvoice/confirmRedinvoiceNotice', params) },
	//红字发票台账 撤回
	revertRedinvoiceNotice: (params) => { return post('/redinvoice/revertRedinvoiceNotice', params) },
	//B类红字流程管理
	queryPendingBRedInvoiceList: (params) => { return post('/isc/bredinvoice/pending-list', params) },
	queryPendingBRedInvoiceDetail: (params) => { return get('/isc/bredinvoice/pending-detail', params) },
	queryBRedInvoiceProcessList: (params) => { return post('/isc/bredinvoice/process-list', params) },
	queryBRedInvoiceProcessListTotalMoney: (params) => { return post('/isc/bredinvoice/process-list-total-money', params) },
	queryBRedInvoiceProcessOrderList: (params) => { return post('/isc/bredinvoice/process-order-list', params) },
	/** 查询B类红字流程红冲明细（调用处注释：第二页签及以后详情抽屉） */
	queryBRedInvoiceProcessDetail: (params) => { return get('/isc/bredinvoice/process-detail', params) },
	initiateBReturnProve: (params) => { return post('/isc/bredinvoice/initiate-return-prove', params) },
	validateBReturnProve: (params) => { return post('/isc/bredinvoice/validate-return-prove', params) },
	queryBReturnProveManualPickItems: (params) => { return post('/isc/bredinvoice/query-manual-pick-items', params) },
	importBReturnProveManualPick: (params) => { return post('/isc/bredinvoice/import-manual-pick-items', params, { headers: { 'Content-Type': 'multipart/form-data' } }) },
	validateBReturnProveInitiate: (params) => { return post('/isc/bredinvoice/validate-return-prove-initiate', params) },
	downloadBReturnProveManualPickImportTemplate: () => { return get('/isc/bredinvoice/download-manual-pick-import-template', null, { responseType: 'blob' }) },
	downloadBReturnProveImportTemplate: (params) => { return post('/isc/bredinvoice/download-return-prove-import-template', params, { responseType: 'blob' }) },
	importBReturnProve: (params) => { return post('/isc/bredinvoice/import-return-prove', params, { headers: { 'Content-Type': 'multipart/form-data' } }) },
	getBRegisterRedInvoiceData: (params) => { return get('/isc/bredinvoice/register-redinvoice-data', params) },
	updateBRegisterRedInvoice: (params) => { return post('/isc/bredinvoice/update-register-redinvoice', params) },
	ocrBRedNotice: (params) => { return post('/isc/bredinvoice/ocr-red-notice', params) },
	/** B类退货证明批量乙方自动签署（上上签 step=1） */
	batchAutoSignBReturnProve: (params) => { return post('/isc/bredinvoice/auto-sign-return-prove', params) },
	//ISC红字发票登记 查询待冲红订单
	queryPendingRedInvoiceOrders: (params) => { return post('/isc/redinvoice/pending-orders', params) },
	//ISC红字发票登记 查询红字流程列表
	queryRedInvoiceProcessList: (params) => { return post('/isc/redinvoice/process-list', params) },
	//ISC红字发票登记 查询红字流程列表汇总金额
	queryRedInvoiceProcessListTotalMoney: (params) => { return post('/isc/redinvoice/process-list-total-money', params) },
	//ISC红字发票登记 查询红字流程订单信息列表
	queryRedInvoiceProcessOrderList: (params) => { return post('/isc/redinvoice/process-order-list', params) },
	//ISC红字发票登记 导入待冲红订单
	importPendingRedInvoiceOrders: (params) => { return post('/isc/redinvoice/import-pending-orders', params) },
	//ISC红字发票登记 待冲红订单导出
	exportPendingRedInvoiceOrderList: (params, config) => { return post(bmsAsyncTask + '/easyPoi/exportPendingRedInvoiceOrderList', params, config) },
	//B类红冲管理 待发起退货证明导出
	exportPendingBRedInvoiceList: (params, config) => { return post(bmsAsyncTask + '/easyPoi/exportPendingBRedInvoiceList', params, config) },
	//B类红冲管理 红字流程导出
	exportBRedInvoiceProcessList: (params, config) => { return post(bmsAsyncTask + '/easyPoi/exportBRedInvoiceProcessList', params, config) },
	//ISC红字发票登记 红字流程导出
	exportRedInvoiceProcessList: (params, config) => { return post(bmsAsyncTask + '/easyPoi/exportRedInvoiceProcessList', params, config) },
	//ISC红字发票登记 查询红字流程详情
	queryRedInvoiceProcessDetail: (params) => { return get('/isc/redinvoice/detail', params) },
	//ISC红字发票登记 查询登记红字发票数据（弹框用）
	getRegisterRedInvoiceData: (params) => { return get('/isc/redinvoice/register-redinvoice-data', params) },
	//ISC红字发票登记 更新登记红字发票（修改三个字段并同步企业微信）
	updateRegisterRedInvoice: (params) => { return post('/isc/redinvoice/update-register-redinvoice', params) },
	//ISC红字发票登记 OCR识别红字确认单
	ocrRedNotice: (params) => { return post('/isc/redinvoice/ocr-red-notice', params) },
	//ISC红字发票登记 发起退货证明
	initiateReturnProve: (params) => { return post('/isc/redinvoice/initiate-return-prove', params) },
	//ISC红字发票登记 登记红字发票
	registerRedInvoice: (params) => { return post('/isc/redinvoice/register', params) },
	//ISC红字发票登记 作废待冲红订单
	voidPendingOrders: (params) => { return post('/isc/redinvoice/void-pending-orders', params) },
	updatePendingOrderRemark: (params) => { return post('/isc/redinvoice/update-pending-order-remark', params) },
	cancelVoidPendingOrders: (params) => { return post('/isc/redinvoice/cancel-void-pending-orders', params) },
	//ISC红字发票登记 撤销红字流程
	revokeRedInvoiceProcess: (params) => { return post('/isc/redinvoice/revoke-process', params) },
	//ISC红字发票登记 审核红字流程
	auditRedInvoiceProcess: (params) => { return post('/isc/redinvoice/audit-process', params) },
	/** ISC 红字流程：按组号更新退货证明链接（return_prove，完整 https） */
	updateReturnProveByGroupNumber: (params) => { return post('/isc/redinvoice/update-return-prove', params) },
	/** B类签署中：上传纸质退货证明并更新状态为待登记红字 */
	updatePaperReturnProve: (params) => { return post('/isc/bredinvoice/update-paper-return-prove', params) },
	generateSaVoucherForRedInvoiceProcess: (params) => { return post('/isc/redinvoice/generate-sa-voucher', params) },
	//运维工作台 SP供应商退款登记 导出
	redinvoiceExport: (params, config) => { return post(bmsAsyncTask + '/redinvoice/export', params, config) },
    //批量下载发票链接
    invoiceZipDown:(params) =>{return post('/easyPoi/invoiceZipDown',params,{responseType: "blob"})},

    /**
	* 采购单模块
	*/
	//采购单台账列表
	getPurchaseOrderList: (params) => { return post('/reqorder/purchase/list', params) },
	//四角订单列表
	getPurchaseSpecialOrderList: (params) => { return post('/reqorder/purchase/specialList', params) },
	// 销项换绑：开票单号下拉
	sellRebindOptions: (params) => { return post('/reqorder/sellRebind/options', params) },
	// 销项换绑：预览
	sellRebindPreview: (params) => { return post('/reqorder/sellRebind/preview', params) },
	// 销项换绑：确认
	sellRebindConfirm: (params) => { return post('/reqorder/sellRebind/confirm', params) },
	// 进项换绑：换绑采购单下拉
	inputRebindOptions: (params) => { return post('/reqorder/inputRebind/options', params) },
	// 进项换绑：预览
	inputRebindPreview: (params) => { return post('/reqorder/inputRebind/preview', params) },
	// 进项换绑：确认
	inputRebindConfirm: (params) => { return post('/reqorder/inputRebind/confirm', params) },
	/**
	* 基础数据维护板块
	*/
	//供应商信息 查询
	PlatformQueryListPage: (params) => { return post('/platform/queryListPage', params) },
	//供应商信息 修改
	PlatformUpdatePlatform: (params) => { return post('/platform/updatePlatform', params) },
	//SP供应商信息 查询
	queryFacilitatorPage: (params,config) => { return post('/facilitator/queryFacilitatorPage', params,config) },
	/** 查看无欠税证明永久地址。调用处：servicerMessage 列表「查看」 */
	taxClearanceFile: (params) => { return post('/facilitator/taxClearance/file', params) },

	queryPlatformPurchaseOrderAndBuyinvoice: (params) => { return post('/purchaseorder/queryPlatformPurchaseOrderAndBuyinvoice', params) },
	queryPlatformPurchaseOrderAndBuyinvoiceExport: (params, config) => { return post('/easyPoi/exportPlatformPurchaseOrderAndBuyinvoice', params, config) },

	getsearchparam: (params) => { return post('/reqorder/financial/getsearchparam', params) },

	//下拉列表信息 查询
	baseDropdownSearch: (params) => { return post('/base/dropdown/search', params) },
	/** 结算员配置姓名下拉 */
	settlerConfigDropdown: (params) => { return post('/base/settlerConfig/dropdown', params || {}) },
  	//供应商信息 查询
  	getPlateList: (params) => { return post('/facilitator/getPlateList', params) },
	//请款复审人列表
  	getSecondAuditor: (params) => { return post('/facilitator/getSecondAuditor', params) },
	//请款人列表
    getPaymentRequestList: (params) => { return post('/srmPay/getAllLabor', params) },
	//对账人列表
    getPartyList: (params) => { return post('/srmBillAuditInfo/getPartyList', params) },//对账人列表
    //审核人列表
    getFinancialList: (params) => { return post('/srmBillAuditInfo/getAuditorList', params) },
     //付款方式列表
  	getPaymentMethodName: (params,config) => { return post('/srmBillAuditInfo/getPaymentMethodName', params,config) },
    //请款人列表
  	getRequestNoList: (params) => { return post('/srm/getPaymentRequestLaborNoList', params) },
	//SP供应商信息 查询
	queryInvoiceNameList: (params) => { return post('/facilitator/queryInvoiceNameList', params) },
	//SP供应商信息 修改
	updateFacilitator: (params) => { return post('/facilitator/updateFacilitator', params) },
	//SP供应商信息 修改spectype
	updateFacilitatorSpec: (params) => { return post('/facilitator/updateFacilitatorSpec', params) },
	//运维工作台 回款单位 查询
	returnedContractList: (params) => { return post('/unnamed/returnedContract/list', params) },
	//运维工作台 回款单位 新增
	returnedContractAdd: (params) => { return post('/unnamed/returnedContract/add', params) },
	//运维工作台 回款单位 编辑
	returnedContractUpdate: (params) => { return post('/unnamed/returnedContract/update', params) },
	//运维工作台 回款单位 选中导出
	returnedContractExportSelective: (params, config) => { return post(bmsAsyncTask + '/unnamed/returnedContract/exportSelective', params, config) },
	//退单记录台账 查询
	queryChargeBackList: (params) => { return post('/reqorder/purchase/queryChargeBackList', params) },
	//退单记录台账 查询
	updateChargeEndStatus: (params) => { return post('/reqorder/purchase/updateChargeEndStatus', params) },
	//退单记录台账 导出
	exportChargeBackList: (params, config) => { return post(bmsAsyncTask + '/reqorder/purchase/exportChargeBackList', params, config) },
	//运维工作台 SP供应商退款登记 查询
	refundRegistRecordQueryList: (params) => { return post('/reqorder/refundRegistRecord/queryList', params) },
	//运维工作台 SP供应商退款登记 导出
	refundRegistRecordExport: (params, config) => { return post(bmsAsyncTask + '/reqorder/refundRegistRecord/export', params, config) },
	//运维工作台 SP供应商退款登记 新增
	refundRegistRecordAdd: (params) => { return post('/reqorder/refundRegistRecord/add', params) },
	//运维工作台 SP供应商退款登记 上传水单并AI识别
	uploadRefundWaterSlipAndRecognize: (params, config) => { return post('/reqorder/refundRegistRecord/uploadWaterSlipAndRecognize', params, config) },
	//运维工作台 SP供应商退款登记 智能识别-粘贴文本
	smartRecognizeRefund: (params) => { return post('/reqorder/refundRegistRecord/smartRecognize', params) },
	//运维工作台 SP供应商退款登记 编辑
	refundRegistRecordUpdate: (params) => { return post('/reqorder/refundRegistRecord/update', params) },
	//查看请款单匹配信息
	getReqMatchInfo: (params) => { return post('/reqorder/getMatchInfo', params) },
	//分页查看请款单匹配成功的记录
	queryListReqMatchSucRecord: (params) => { return post('/reqorder/queryListMatchSucRecord', params) },
	//分页查看请款单采购单物料匹配失败的记录
	queryListReqNonMatchPurchaseRecord: (params) => { return post('/reqorder/queryListNonMatchPurchaseRecord', params) },
	//分页查看请款单签收单物料匹配失败的记录
	queryListReqNonMatchSignedRecord: (params) => { return post('/reqorder/queryListNonMatchSignedRecord', params) },
	matchSignedRecordManual: (params) => { return post('/reqorder/manualMatch', params) },
	//获取请款单详情
	getReqOrderDetailByReqOrderNo: (params) => { return get('/reqorder/getReqOrderDetailByReqOrderNo'+ params) },
	//请款详情抵扣协议 Tab
	listAiFeeDeductAgreements: (params) => { return get('/reqorder/aiFee/deduct/agreements', params) },
	//获取财务审批抽屉当前阶段状态
	getReqOrderAuditStageStatus: (params) => { return get('/reqorder/getReqOrderAuditStageStatus', params) },
	//获取采购单列表
	pageListPurchaseSignedDetail: (params) => { return post('/reqorder/pageListPurchaseSignedDetail', params) },
	//采购单换单
	purchaseOrderChangeOrder: (params) => {return post('/purchaseorder/change/purchase/order', params)},
	//预付款核销台账 导出
	advanceExportList:(params,config) =>{return post(bmsAsyncTask + '/advanceVerification/exportList',params,config)},
	//核销单据审核 导出
	exportVerificationList:(params,config) =>{return post(bmsAsyncTask + '/advanceVerification/exportVerificationList',params,config)},
	//S单SP供应商名单、缴费记录表 下拉选项查询
	queryDistinctCol: (params) => { return post('/tenpaymentrecord/queryDistinctCol', params) },
	//S单SP供应商名单 查询
	servicertentypeList: (params) => { return post('/servicertentype/list', params) },
	//S单SP供应商名单 查询
	servicertentypeDetailList: (params) => { return post('/servicertentype/detailList', params) },
	//S单SP供应商名单详情 查询
	queryServicertentype: (params) => { return get('/servicertentype/query/detail'+ params) },
	//S单SP供应商名单详情 编辑
	editServicertentype: (params) => { return post('/servicertentype/edit', params) },
	//S单SP供应商额度组 保存或新增
	saveOrUpdateTentypeGroup: (params) => { return post('/servicertentype/saveOrUpdateGroup', params) },
	//S单SP供应商名单 导出
	servicertentypeExport: (params) => { return post(bmsAsyncTask + '/servicertentype/export', params, { responseType: "blob" }) },
	//S单SP供应商名单 导入
	servicertentypeImp: (params, config) => { return post('/servicertentype/imp', params, config) },
	//S单SP供应商名单 禁用
	servicertentypeDelBatch: (params) => { return post('/servicertentype/delBatch', params) },
	//缴费记录表 查询
	tenpaymentrecordList: (params) => { return post('/tenpaymentrecord/list', params) },
	/** 商务 PC：按合同查十大类/S单缴费记录（同源 o2o queryTenpaymentRecord，勿调 /o2o/） */
	queryTenpaymentRecordByContract: (params) => { return post('/reqorder/tenpayment/queryByContract', params) },
	//缴费记录表 导出
	tenpaymentrecordExport: (params) => { return post(bmsAsyncTask + '/tenpaymentrecord/export', params, { responseType: "blob" }) },
	//缴费记录表 审核
	tenpaymentrecordAudit: (params) => { return post('/tenpaymentrecord/audit', params) },
	//缴费记录表 驳回
	tenpaymentrecordReject: (params) => { return post('/tenpaymentrecord/reject', params) },
	//提交缴费记录凭证
	tenpaymentrecordSubmitProof:(params) =>{return post('/tenpaymentrecord/submitProof',params)},
	//缴费记录表 开票单据下载
	exportInvoiceTemplate: (params) => { return post('/tenpaymentrecord/exportInvoiceTemplate', params, { responseType: "blob" }) },
	//缴费记录表 登记发票
	tenpaymentrecordRegisterInvoice: (params) => { return post('/tenpaymentrecord/registerInvoice', params) },
	//签收单审批 查询
	querySignedAuditList: (params) => { return post('/signedAudit/queryListPage', params) },
	//签收单审批 导出
	exportSignedAuditList: (params, config) => { return post(bmsAsyncTask + '/signedAudit/export', params, config) },
	signedAuditSubmit: (params) => { return post('/signedAudit/audit', params) },

	/**
	* 报表管理
	*/
	//已发货未开票 查询
	queryShippedUnbilledOrderPage: (params) => { return post('/reportmanagement/queryShippedUnbilledOrderPage', params) },

	/**
	* 请款单管理
	*/
	//请款审批-编辑-查询银行信息
	queryBankInfo: (params) => { return post('/reqorder/queryBankInfo', params) },
	//请款审批-编辑-修改银行信息
	updateBankInfo: (params) => { return post('/reqorder/updateBankInfo', params) },
	//财务-请款台账-获取支付信息
	queryPaymentMethod: (params) => { return post('reqorder/queryPaymentMethod', params) },
	//支付指令台账-供应商出纳
	submitPlatformCashier: (params) => { return post('reqorder/submitPlatformCashier', params) },
	//财务-请款台账-获取付款凭证信息
	getPaymentVoucher: (params) => { return post('/reqorder/getPaymentVoucher', params) },
	//财务-请款台账-提交付款凭证信息
	submitPaymentVoucher: (params) => { return post('/reqorder/submitPaymentVoucher', params) },
	//SP供应商罚款台账-查询
	queryServicerCostItems: (params) => { return post('/servicercost/queryServicerCostItems', params) },
	//SP供应商罚款台账-编辑商务备注
	updateServicerCostItems: (params) => { return post('/servicercost/updateServicerCostItems', params) },
	//SP供应商罚款台账-导入
	servicercostImportItems: (params) => { return post('/servicercost/importItems', params) },
	//SP供应商罚款台账-查询所属公司
	achievementList: (params) => { return post('/reqorder/achievement/list', params) },
	//B2B财务报表-供应商余额报表-查询
	supplierBalanceReport: (params) => { return post('/supplierBalance/report', params) },
	//B2B财务报表-供应商余额报表-合计
	supplierBalanceReportAmountSum: (params) => { return post('/supplierBalance/amountSum', params) },
	//B2B财务报表-供应商余额报表-导出
	supplierBalanceExport: (params) => { return post('/supplierBalance/export', params) },
	//B2B财务报表-供应商余额报表-下载明细
	supplierBalanceExportDetail: (params) => { return post('/supplierBalance/exportDetail', params) },
	//B2B财务报表-供应商余额报表-期初明细查询
	supplierOpeningBalanceDetailPageList: (params) => { return post('/supplierOpeningBalanceDetail/pageList', params) },
	//B2B财务报表-供应商余额报表-期初明细导出
	supplierOpeningBalanceDetailExport: (params) => { return post('/supplierOpeningBalanceDetail/export', params) },
	// B2B财务报表-供应商来票报表-查询
	supplierSpInvoiceAmountReport: (params) => { return post('/supplierSpInvoiceAmountReport/pageList', params) },
	// B2B财务报表-供应商来票报表-合计
	supplierSpInvoiceAmountReportSum: (params) => { return post('/supplierSpInvoiceAmountReport/amountSum', params) },
	// B2B财务报表-供应商来票报表-导出（支持勾选 exportLineList）
	supplierSpInvoiceAmountReportExport: (params) => { return post('/supplierSpInvoiceAmountReport/export', params) },
	// SP供应商来票报表-查询
	supplierInvoiceReport: (params) => { return post('/supplierBalance/invoicePageList', params) },
	// SP供应商来票报表-合计
	supplierInvoiceReportAmountSum: (params) => { return post('/supplierBalance/invoiceAmountSum', params) },
	// SP供应商来票报表-导出
	supplierInvoiceExport: (params) => { return post('/supplierBalance/invoiceExport', params) },
	// SP供应商来票报表-下载明细
	supplierInvoiceExportDetail: (params) => { return post('/supplierBalance/invoiceExportDetail', params) },
	// B2B财务报表-供应商/SP供应商下拉选项
	supplierSpOptions: (params) => { return post('/supplierBalance/supplierSpOptions', params) },
	//SP供应商罚款台账-查询白名单列表
	queryWhiteList: (params) => { return post('/servicercost/queryWhiteList', params) },
	//SP供应商罚款台账-添加白名单
	addWhiteList: (params) => { return post('/servicercost/addWhiteList', params) },
	//SP供应商罚款台账-删除白名单
	removeWhiteList: (params) => { return post('/servicercost/removeWhiteList', params) },
	//SP供应商罚款台账-SP供应商期末结余合计
	queryEndingBalanceCount: (params) => { return post('/servicercost/queryEndingBalanceCount', params) },
	// SP供应商罚款缴纳通知函
	fineNoticeUploadAttachment: (params) => { return post('/servicercost/fineNotice/uploadAttachment', params, { headers: { 'Content-Type': 'multipart/form-data' } }) },
	// AI服务费框架协议
	aiFrameworkQueryPage: (params) => { return post('/aiFramework/queryPage', params) },
	aiFrameworkImportServicerList: (params) => { return post('/aiFramework/importServicerList', params, { headers: { 'Content-Type': 'multipart/form-data' } }) },
	aiFrameworkImportSupplierList: (params) => { return post('/aiFramework/importSupplierList', params, { headers: { 'Content-Type': 'multipart/form-data' } }) },
	aiFrameworkDownloadImportTemplate: () => { return get('/aiFramework/downloadImportTemplate', {}, { responseType: 'blob' }) },
	// 批量延期逾期未签框架协议
	aiFrameworkExtendOverdueContracts: (params) => { return post('/aiFramework/extendOverdueContracts', params) },
	// AI服务费管理
	aiServiceFeeQueryPage: (params) => { return post('/aiServiceFee/queryPage', params) },
	aiServiceFeeConfigQuery: () => { return post('/aiServiceFee/config/query', {}) },
	aiServiceFeeConfigSave: (params) => { return post('/aiServiceFee/config/save', params) },
	// 调用处注释：服务费台账列表异步导出，字段与列表列一致
	aiServiceFeeExport: (params) => { return post('/aiServiceFee/export', params) },
	// 调用处注释：下载开票信息异步导出，任务管理-导出可查
	aiServiceFeeDownloadInvoice: (params) => { return post('/aiServiceFee/downloadInvoiceInfo', params) },
	// 调用处注释：导入发票异步任务，任务管理-导入记录可查
	aiServiceFeeImportInvoice: (params) => { return post('/aiServiceFee/importInvoice', params, { headers: { 'Content-Type': 'multipart/form-data' } }) },
	// 调用处：服务费管理「获取金税发票」，按发票号码拉渠道 70/90
	aiServiceFeePullInvoice: (params) => { return post('/aiServiceFee/pullInvoice', params) },
	/** AI服务费现金支付记录分页 */
	aiServiceFeePaymentPageList: (params) => { return post('/aiServiceFeePayment/pageList', params) },
	/** AI服务费现金支付记录详情 */
	aiServiceFeePaymentDetail: (params) => { return post('/aiServiceFeePayment/detail', params) },
	/** AI服务费支付记录异步导出，字段与列表列一致 */
	aiServiceFeePaymentExport: (params) => { return post('/aiServiceFeePayment/export', params) },
	/** 对公审核通过 */
	aiServiceFeePaymentAuditApprove: (params) => { return post('/aiServiceFeePayment/auditApprove', params) },
	/** 对公审核驳回 */
	aiServiceFeePaymentAuditReject: (params) => { return post('/aiServiceFeePayment/auditReject', params) },
	/** 对公待审核批量通过。调用处：aiServiceFeePayment.vue 批量通过 */
	aiServiceFeePaymentAuditBatchApprove: (params) => { return post('/aiServiceFeePayment/auditBatchApprove', params) },
	/** 对公待审核批量驳回。调用处：aiServiceFeePayment.vue 批量驳回 */
	aiServiceFeePaymentAuditBatchReject: (params) => { return post('/aiServiceFeePayment/auditBatchReject', params) },
	//采购单台账-获取SP供应商期末结余明细
	queryServicerEndingBalance: (params) => { return post('/servicercost/queryServicerEndingBalance', params) },
    //SP供应商商务请款台账-票据审批
    billAudit: (params) => { return post('/reqorder/billAudit', params) },
	//SP供应商管控-查询
	serviceControlList: (params) => { return post('/servicercost/query/service/requisition/delay/control/list', params) },
	//SP供应商管控-编辑
	serviceControlEdit: (params) => { return post('/servicercost/update/service/requisition/delay/control/info', params) },
	//SP供应商管控-新增
	serviceControlAdd: (params) => { return post('/servicercost/addServicerControl', params) },
	//SP供应商管控-禁用
	deleteServicerControl: (params) => { return post('/servicercost/deleteServicerControl', params) },
	//SP供应商管控-导入
	serviceControlImport: (params) => { return post('/servicercost/import/service/requisition/delay/control', params) },
	//SP供应商管控-导出
	serviceControlExport: (params) => { return post(bmsAsyncTask + '/servicercost/export/service/requisition/delay/control/list', params, { responseType: "blob" }) },
	/**
	* 订单应收管理RMS
	*/
	//获取查询模块下拉选项
	rmsHomeProjectList: (params) => { return post('/receivable/rmsQueryParam', params) },
	//获取查询模块下拉选项
	receivableQueryParam: (params) => { return post('/receivable/queryParam', params) },
	//查询列表
	receivableList: (params) => { return post('/receivable/list', params) },
	//详情-跟进记录
	feedbackRecord: (params, config) => { return post('/receivable/feedbackRecord', params, config) },
	//详情-订单信息
	receivableDetailInfo: (params) => { return post('/receivable/detailInfo', params) },
	//详情-物料明细
	queryOrderTempWithItem: (params, config) => { return post('/receivable/queryOrderTempWithItem', params, config) },
	//反馈-提交
	receivableSubmitFeedback: (params, config) => { return post('/receivable/submitFeedback', params, config) },
	//批量反馈-提交
	receivableBatchSubmitFeedback: (params) => { return post('/receivable/batchSubmitFeedback', params) },
    //批量反馈-导入
    importFeedback: (params) => { return post('/receivable/importFeedback', params) },
	//批量反馈-导入
	receivableSubmitOA: (params) => { return post('/receivable/receivableSubmitOA', params) },
	//提交OA-查询附件
	receivableGetImageUrlByVbelns: (params) => { return post('/receivable/getImageUrlByVbelns', params) },
	//批量反馈-导入
	receivableSubmitForward: (params) => { return post('/receivable/receivableSubmitForward', params) },
	//导出
	receivableExport: (params, config) => { return post(bmsAsyncTask + '/receivable/exportBMS', params, config) },
	//批量导入跟进人
	receivableImportFollowupPeople: (params, config) => {
		return post('/receivable/importFollowupPeople', params, {
			headers: { "Content-Type": "multipart/form-data" }, ...config
		})
	},
	//查询用户接口信息
	receivableListEmployeeOrg: (params) => { return post('/receivable/listEmployeeOrg', params) },
	//查询应收账龄报表
	queryAgingReport: (params) => { return post('/receivable/queryAgingReport', params) },
	//查询应收账龄报表
	sendAgingReportDetailToEmail: (params, config) => { return post(bmsAsyncTask + '/receivable/sendAgingReportDetailToEmail', params, config) },
	//批量分配
	receivableUpdateBatch: (params) => { return post('/receivable/updateBatch', params) },
	//移动端-查询列表
	receivableQyweixinList: (params) => { return post('/receivable/qyweixin/list', params) },
	//移动端-查询明细列表
	receivableQyweixinDetails: (params, config) => { return post('/receivable/qyweixin/details', params, config) },
	//移动端-子公司数据汇总
	receivableQyweixinDetail: (params) => { return post('/receivable/qyweixin/detail', params) },
	//企业微信开通bms账号
	createUser: (params) => { return post('/api/createUser', params) },
	//S单SP供应商名单详情 查询
	apiListBank: (params) => { return get('/api/listBank'+ params) },
	//S单SP供应商白名单 查询
	servicertentypeQueryWhiteList: (params) => { return post('/api/servicertentype/queryWhiteList', params) },
	//上传文件 查询
	uploadFileToOss: (params) => { return post('/api/uploadFileToOss', params) },

	/**
	* 公共接口
	*/
	// 供应商 购销合同校验接口
	verifyMethod: (params) => { return post('/purchaseorder/verifyMethod', params) },
	// 进项 购销合同校验接口
	otoVerifyMethodJin: (params) => { return post('/purchaseorder/otoVerifyMethodJin', params) },
	// SP供应商发票台账 购销合同校验接口
	fuVerifyMethod: (params) => { return post('/purchaseorder/fuVerifyMethod', params) },
	// 合同列表查询
	qureySysCustomerContract: (params) => { return post('/contract/qureySysCustomerContract', params) },
	// 查询发票物流信息
	queryInvoiceLogistics: (params) => { return get('/reqorder/queryInvoiceLogistics' + params) },
	// 查询用户权限
	queryPrivileges: (params) => { return post('/base/queryPrivileges', params) },
	// 查询按钮权限
	baseQueryButton: (params) => { return post('/base/queryButton', params) },
	// 进项发票台账
	updateVoucherInfo: (params) => { return post('/buyinvoice/updateVoucherInfo', params) },

	/**
	* 外部业务
	*/
	// 华夏银行保理-查询供应商信息列表
	hxbankQueryCompanyInfo: (params) => { return post('/hxbank/queryCompanyInfo', params) },
	// 华夏银行保理-创建账户
	hxbankCreateCompanyAccount: (params) => { return post('/hxbank/createCompanyAccount', params) },
	// 华夏银行保理-申请融资
	hxbankFundingApply: (params) => { return post('/hxbank/fundingApply', params) },
	// 华夏银行保理-再次融资
	hxbankFundingAgain: (params) => { return post('/hxbank/fundingAgain', params) },
	// 华夏银行保理-上传excel
	hxbankImportExcel: (params) => { return post('/hxbank/importExcel', params) },
	// 华夏银行保理-上传PDF
	hxbankUploadPdf: (params) => { return post('/hxbank/uploadPdf', params) },
	// 华夏银行保理-上传转让通知书
	hxbankUploadNoticePdf: (params) => { return post('/hxbank/uploadNoticePdf', params) },
	// 华夏银行保理-下载转让通知书
	hxbankDownloadNotice: (params) => { return post('/hxbank/downloadNotice' + params, {}, { responseType: "blob" }) },

	/**
	* SRM供应商结算
	*/
	//SRM红字发票申请台账 查询
	getRedinvoiceRequestsList: (params) => { return post('/bill/getRedinvoiceRequestsList', params) },
	//运维工作台 SP供应商退款登记 导出
	srmRedinvoiceExport: (params, config) => { return post(bmsAsyncTask + '/bill/srmRedinvoiceExport', params, config) },
	exportSrmRedinvoiceRequestsDetail: (params, config) => { return post(bmsAsyncTask + '/bill/exportSrmRedinvoiceRequestsDetail', params, config) },
	//SRM红字发票申请台账 查询
	revertSrmRedRequests: (params) => { return post('/bill/revertSrmRedRequests', params) },
	createSAVoucher: (params) => { return post('/bill/createSAVoucher', params) },
	//SRM红字发票-更新退款状态
	updateRefundStatus: (params) => { return post('/bill/updateRefundStatus', params) },
	// 对账单审核-查询列表
	querySrmBillAuditPage: (params,config) => { return post('/srmBillAuditInfo/queryPage', params,config) },
	// 对账单审核-审核
	auditSrmBill: (params, config) => { return post('/srmBillAuditInfo/audit', params,config) },
	// 对账单审核-撤回
	withdraw: (params) => { return post('/srmBillAuditInfo/withdraw', params) },
	// 对账单审核-详情
	querySrmBillDetail: (params,config) => { return post('/srmBillAuditInfo/getDetail', params,config) },
	// 对账单审核-凭证列表
	pageListSrmBillVoucherDetails: (params,config) => { return post('/srmBillAuditInfo/pageListVoucherDetails', params,config) },
	// 对账单台账-发票校验
	checkInvoice: (params) => { return post('/srmBillAuditInfo/checkInvoice', params) },
	// 对账单台账-发票校验
	checkInvoiceSAVoucher: (params) => { return post('/srmBillAuditInfo/checkInvoiceSAVoucher', params) },
	// 对账单台账-取消发票校验
	cancelCheckInvoice: (params) => { return post('/srmBillAuditInfo/cancelCheckInvoice', params) },
	// 对账单台账-维护发票
	maintainSrmBillInvoice: (params) => { return post('/srmBillAuditInfo/maintainInvoice', params) },
    //对账单台账-导出
    exportSrmBillExcel: (params) => { return post(bmsAsyncTask + '/srmBillAuditInfo/export', params) },
    //SRM采购单-导出
    exportSrmPurOrderExcel: (params) => { return post(bmsAsyncTask + '/srmPurchaseOrder/export', params )},
	//QF采购单-导出
    exportQFPurOrderExcel: (params) => { return post(bmsAsyncTask + '/qfPurchaseOrder/export', params) },
    // SRM采购订单-获取列表
	querySrmPurchseOrderPage: (params) => { return post('/srmPurchaseOrder/queryPageList', params) },
	// QF采购订单-获取列表
	queryQFPurchseOrderPage: (params) => { return post('/qfPurchaseOrder/queryPageList', params) },
	// SRM过账物料台账-获取列表
	querySrmPostingItemBookPage: (params) => { return post('/srmPurchaseOrder/querySrmPostingItemBookPage', params) },
	// QF过账物料台账-获取列表
	queryQFPostingItemBookPage: (params) => { return post('/qfPurchaseOrder/queryQFPostingMaterialLegerPage', params) },
	// SRM采购订单-获取详情
	querySrmPurchseOrderDetail: (params) => { return post('/srmPurchaseOrder/getDetail', params) },
	// QF采购订单-获取详情
	queryQFPurchseOrderDetail: (params) => { return post('/qfPurchaseOrder/getDetail', params) },
	// 请款审核-获取列表
	querySrmPayPage: (params) => { return post('/srmPay/pageList', params) },
	// 请款审核-获取列表
	querySrmPrepaidVerificationPage: (params) => { return post('/srmPay/querySrmPrepaidVerificationPage', params) },
	// 请款审核-获取列表
	querySrmPayDetail: (params) => { return post('/srmPay/getDetail', params) },
	// 请款审核-审核（同意校验）
  	checkHasBill: (params) => { return post('/srmPay/checkHasBill', params) },
	// 请款审核-审核（同意、驳回）
	auditSrmPay: (params) => { return post('/srmPay/audit', params) },
	// 请款审核-请款单待提交OA
	submitSrmPayOA: (params) => { return post('/srmPay/submitOA', params) },
	// 请款审核-请款单提交SAP
	submitSrmPaySAP: (params) => { return post('/srmPay/submitSAP', params) },
	// 罚款支付审核-获取列表
	querySrmFinePayPage: (params) => { return post('/srmFinePay/pageList', params) },
	// 罚款支付审核-审核人下拉（历史去重）
	listSrmFinePayAuditors: (params) => { return post('/srmFinePay/listAuditors', params || {}) },
	// 罚款支付审核-详情
	querySrmFinePayDetail: (params) => { return post('/srmFinePay/getDetail', params) },
	// 罚款支付审核-审核（通过/驳回）
	auditSrmFinePay: (params) => { return post('/srmFinePay/audit', params) },
	// 罚款支付审核-提交凭证
	submitSrmFinePayVoucher: (params) => { return post('/srmFinePay/submitVoucher', params) },
	// 调用处注释：罚款支付审核列表异步导出，字段与列表列一致。
	exportSrmFinePayExcel: (params) => { return post(bmsAsyncTask + '/srmFinePay/export', params) },
	// 请款审核-驳回请款单
  	rejectSrmPay: (params) => { return post('/srmPay/rejectSrmPay', params) },
	//请款审核-请款单支付导入
	payImportExcel: (params) => { return post('/srmPay/payImportExcel', params) },
	//请款审核-导出
	exportSrmPayExcel: (params) => { return post(bmsAsyncTask + '/srmPay/export', params) },
	// 请款审核-设置抵扣，凭证列表
	querySrmOtherDeduction: (params) => { return post('/srmOtherDeduction/pageList', params) },
	// 请款审核-设置抵扣，审核通过
	auditPassSrmOtherDeduction: (params) => { return post('/srmOtherDeduction/auditPass', params) },
	// 请款审核-同意，前置检查
	checkHasSaVoucher: (params) => { return post('/srmOtherDeduction/checkHasSaVoucher', params) },
	// 请款审核-同意，取消提交
	showDeductionButton: (params) => { return post('/srmOtherDeduction/showDeductionButton', params) },
	//预付核销台账-导出
	exportPrepaidVerificationExcel: (params) => { return post(bmsAsyncTask + '/srmPay/exportPrepaidVerificationExcel', params) },
	//SRM过账物料台账-导出
	exportSrmPostingItemExcel: (params) => { return post(bmsAsyncTask + '/srmPurchaseOrder/exportSrmPostingItemExcel', params) },
	//QF过账物料台账-导出
	exportQFPostingItemExcel: (params) => { return post(bmsAsyncTask + '/qfPurchaseOrder/exportQFPostingItemExcel', params) },
	// SRM供应商退款-查询列表
	srmRefundQueryList: (params) => { return post('/srmRefund/queryList', params) },
	// SRM供应商退款-查询收款主体列表
	srmRefundGetEnterpriseAll: (params) => { return post('/srmRefund/getEnterpriseAll', params) },
	// SRM供应商退款-导出
	srmRefundExport: (params) => { return post(bmsAsyncTask + '/srmRefund/export', params, { responseType: "blob" }) },
	// SRM供应商退款-审核通过
	srmRefundAudit: (params) => { return post('/srmRefund/audit', params) },
	// SRM供应商退款-驳回
	srmRefundReject: (params) => { return post('/srmRefund/reject', params) },
	// SRM供应商退款-清账
	srmRefundSettle: (params) => { return post('/srmRefund/settle', params) },
	//提交通知单
	uploadSrmRedNotice:(params) => { return post('/bill/uploadSrmRedNotice', params) },
	//SP供应商标签列表 查询
	queryServicerTags: (params) => { return post('/facilitator/queryServicerTags', params) },
	/**
	 * 平台结算单管理
	 */
	//上传结算单
	platformUploadSettlementFile: (params) => { return post('/platform/settlement/importSettlementFile', params) },
	//查询结算单列表
	queryPlatformSettlementListPage: (params) => { return post('/platform/settlement/queryListPage', params) },
	//查询下拉列表
	queryPlatformSettlementDropSelectList: (params) => { return post('/platform/settlement/listQuerySelect', params) },
	//审核结算单
	auditPlatformSettlementOrder: (params) => { return post('/platform/settlement/approveOrder', params) },
	//平台结算单确认已支付
	platformSettlementPaid: (params) => { return post('/platform/settlement/paidOrder', params) },
	//删除结算单
	deleteSettlementOrder: (params) => { return post('/platform/settlement/deleteSettlementOrder', params) },
	//确认结算单
	confirmSettlementOrder: (params) => { return post('/platform/settlement/confirmSettlementOrder', params) },
	//查询结算单详情
	queryPlatformSettlementDetailListPage: (params) => { return post('/platform/settlement/queryDetailListPage', params) },
	//上传结算结果
	platformUploadSettlementPaymentFile: (params) => { return post('/platform/settlement/importSettlementOrderPayment', params) },
	//导出结算单
	platformSettlementExportList:(params,config) =>{return post(bmsAsyncTask + '/platform/settlement/export',params,config)},
	//主页-srm请款单导入
    srmReqImportExecl: (params) => { return post('/srm/upload', params) },
	//主页-子公司SP供应商请款单导入
    reqImportExecl: (params) => { return post('/reqorder/req/upload', params) },
	//主页-子公司SP供应商请款单导入
	unlockPoUpload: (params) => { return post('/purchaseorder/unlockPoUpload', params) },
	//主页-解锁采购单导入
	unlockPurchaseOrderUpload: (params) => { return post('/purchaseorder/unlockPurchaseOrderUpload', params) },
	clearAccrualImport: (params) => { return post('/purchaseorder/clearAccrualImport', params) },
	//主页-释放采购单请款状态
	releasePurchaseOrderPaymentStatus: (params) => { return post('/purchaseorder/releasePurchaseOrderPaymentStatus', params) },

    /***** 首页 *****/
    //系统公告
    getBaseParams: (params) => { return post('/base/getParams', params) },
    //意见反馈
    baseSubmitFeedback: (params) => { return post('/base/submitFeedback', params) },
    //我的单据
    getLatestOrdersByOperator: (params) => { return get('/base/getLatestOrdersByOperator', params) },
    //SP采购订单日志
    getPurchaseorderlogList: (params) => { return post('/purchaseorderlog/pageList', params) },
    //学习中心
    getLearnFileList: (params) => { return post('/learnFile/pageList', params) },
    //我的通知
    todoPageTODO: (params) => { return get('/todo/pageTODO', params) },
    /***** 首页 end *****/
    // 主页-学习文件表单
	learnFileAdd: (params) => { return post('/learnFile/save', params) },
	baseParams: (params) => { return post('/base/getParams', params) },

	//平台结算订单导入
	importSettlementOrder: (params) => { return post('/platform/settlement/importOrder', params) },

	//查询平台结算订单导入列表
	orderImportList: (params) => { return post('/platform/settlement/orderImportList', params) },

	getApiRequestLogPage: (params) => { return post('/reqApiLog/page', params) },

	getApiRequestLogSelector: () => { return get('/reqApiLog/selector') },

	apiReqRetry: (params) => { return post('/reqApiLog/reqSystem', params) },

	apiReqTerminate: (params) => { return post('/reqApiLog/terminate', params) },

	/** 查询子流程日志（父子日志展开用） */
	getApiRequestLogChildren: (parentGroupId) => { return get('/reqApiLog/children/' + parentGroupId) },

	/** 查询外部接口调用详情（消息报文 + API 原始报文） */
	getApiRequestLogDetail: (groupId) => { return get('/reqApiLog/detail/' + groupId) },

	// 税分类缓存
	taxCategoryCacheQueryListPage: (params) => { return post('/taxCategoryCache/queryListPage', params) },
	taxCategoryCacheGetById: (params) => { return get('/taxCategoryCache/getById', params) },
	taxCategoryCacheAdd: (params) => { return post('/taxCategoryCache/add', params) },
	taxCategoryCacheUpdate: (params) => { return post('/taxCategoryCache/update', params) },
	taxCategoryCacheDelete: (params) => { return post('/taxCategoryCache/delete', params) },

	// 结证通-请款附件台账
	attachmentLedgerPage: (params) => { return post('/attachmentLedger/page', params) },
	attachmentLedgerBatchDelete: (params) => { return post('/attachmentLedger/batchDelete', params) },
	attachmentLedgerBatchUpdateStatus: (params) => { return post('/attachmentLedger/batchUpdateStatus', params) },
	/** 调用处：请款附件台账导出 */
	attachmentLedgerExport: (params) => { return post('/attachmentLedger/export', params, { responseType: 'blob' }) },
	/** 调用处：请款附件台账智能查找回执 */
	attachmentLedgerSmartSearch: (params) => { return post('/attachmentLedger/smartSearch', params) },
	/** 调用处：智能查找弹框选用并绑定 */
	attachmentLedgerSmartBind: (params) => { return post('/attachmentLedger/smartBind', params) },

	/** 集采结算-汇总付款附件 */
	cpPaymentAttachmentLedgerPage: (params) => { return post('/cpPaymentAttachmentLedger/page', params) },
	cpPaymentAttachmentLedgerExport: (params) => { return post('/cpPaymentAttachmentLedger/export', params, { responseType: 'blob' }) },
	cpPaymentAttachmentLedgerBatchDelete: (params) => { return post('/cpPaymentAttachmentLedger/batchDelete', params) },
	cpPaymentAttachmentLedgerBatchUpdateStatus: (params) => { return post('/cpPaymentAttachmentLedger/batchUpdateStatus', params) },

	// 结证通-AI回单识别台账
	bankReceiptLedgerPage: (params) => { return post('/bankReceiptLedger/page', params) },
	bankReceiptLedgerUpdate: (params) => { return post('/bankReceiptLedger/update', params) },
	bankReceiptLedgerBatchClearOrderNo: (params) => { return post('/bankReceiptLedger/batchClearOrderNo', params) },
	bankReceiptLedgerBatchReRecognize: (params) => { return post('/bankReceiptLedger/batchReRecognize', params) },
	/** AI回单台账预绑定（试匹配请款单，不落库） */
	bankReceiptLedgerPreBind: (params) => { return post('/bankReceiptLedger/preBind', params) },
	/** AI回单台账编辑并绑定 */
	bankReceiptLedgerUpdateAndBind: (params) => { return post('/bankReceiptLedger/updateAndBind', params) },

	// 表头配置相关接口
	getTableHeaderSetting: (params) => { return post('/base/headerSetting/getModuleSetting', params) },
	saveTableHeaderSetting: (params) => { return post('/base/headerSetting/save', params) },
	// 关注列表相关接口（预留）
	getFollowList: (params) => { return get('/base/userCollection/contractProjects', params) },
	getFindUserContractProjects: (params) => { return get('/reqorder/purchase/findUserContractProjects', params) },
	addFollowItem: (params) => { return post('/base/userCollection/saveContractProjects', params) },
	removeFollowItem: (params) => { return post('/base/userCollection/removeContractProjects', params) },
	// 关账配置
	queryCloseTimeConfig: (params) => { return post('/base/closeTimeConfig/query', params) },
	updateCloseTimeConfig: (params) => { return post('/base/closeTimeConfig/update', params) },
	// 退货证明允许日期范围配置
	queryTaxClearanceCheck: () => { return post('/base/taxClearanceCheck/query', {}) },
	updateTaxClearanceCheck: (params) => { return post('/base/taxClearanceCheck/update', params) },
	queryReturnProveDateRange: () => { return post('/base/returnProveDateRange/query', {}) },
	updateReturnProveDateRange: (params) => { return post('/base/returnProveDateRange/update', params) },
	// 运维工作台 银行流水获取
	scanBankFlow: () => { return post('/base/bankFlow/scan', {}) },
	// 进项发票文件格式配置
	queryBuyInvoiceFileFormat: () => { return post('/base/buyInvoiceFileFormat/query', {}) },
	queryBuyInvoiceFileFormatByScope: (params) => { return post('/base/buyInvoiceFileFormat/queryByScope', params) },
	updateBuyInvoiceFileFormat: (params) => { return post('/base/buyInvoiceFileFormat/update', params) },
	// 国际汇率配置
	importExchangeRates: (params, config) => { return post('/exchangeRate/import', params, config) },
	queryLatestExchangeRates: (params) => { return post('/exchangeRate/queryLatest', params) },
	downloadExchangeRateTemplate: () => { return get('/exchangeRate/downloadTemplate', null, { responseType: 'blob' }) },

	// 齐心收款方式配置
	returnedPaymentConfigQueryListPage: (params) => { return post('/returnedPaymentConfig/queryListPage', params) },
	returnedPaymentConfigAdd: (params) => { return post('/returnedPaymentConfig/add', params) },
	returnedPaymentConfigUpdate: (params) => { return post('/returnedPaymentConfig/update', params) },
	returnedPaymentConfigGetByCode: (params) => { return get('/returnedPaymentConfig/getByCode', params) },
	returnedPaymentConfigAiRecognize: (params) => { return post('/returnedPaymentConfig/aiRecognize', params) },
	returnedPaymentConfigGetAllEnterpriseList: () => { return get('/returnedPaymentConfig/getAllEnterpriseList') },

	/** 会计凭证清帐台账分页 */
	servicerVoucherClearPage: (params) => { return post('/servicerVoucherClear/page', params) },
	/** 台账公司下拉（当前用户数据权限） */
	servicerVoucherClearAuthCompanies: () => { return post('/servicerVoucherClear/authCompanies', {}) },
	/** 发起清帐弹框：可清帐组列表 */
	servicerVoucherClearListClearGroups: (params) => { return post('/servicerVoucherClear/listClearGroups', params || {}) },
	/** 发起清帐确认提交 */
	servicerVoucherClearSubmitClear: (params) => { return post('/servicerVoucherClear/submitClear', params) },
	/** 会计凭证清帐台账批量改手工 */
	servicerVoucherClearBatchToManual: (params) => { return post('/servicerVoucherClear/batchToManual', params) },
	/** 会计凭证清帐台账反清帐（FICO105） */
	servicerVoucherClearReverseClear: (params) => { return post('/servicerVoucherClear/reverseClear', params) },
	/** 会计凭证清帐台账导出（异步任务） */
	servicerVoucherClearExport: (params, config) => { return post('/servicerVoucherClear/export', params, config) },

	// ======================== 子公司负责人逾期反馈 ========================
	/** 子公司负责人逾期订单列表 */
	receivableSubsidiaryLeaderList: (params) => { return post('/receivable/subsidiary/leader/list', params) },
	/** 标记订单已读 */
	receivableMarkRead: (params, config) => { return post('/receivable/subsidiary/leader/markRead', params, config) },
	/** 催业务员跟进 */
	receivableUrgeFollowUp: (params, config) => { return post('/receivable/subsidiary/leader/urge', params, config) },
	/** 批量催办 */
	receivableBatchUrge: (params) => { return post('/receivable/subsidiary/leader/batchUrge', params) },


	/** 集采采销一体-结算端订单分页 */
	cpSettlementSalePurchaseOrderPage: (params) => { return post('/cp/salePurchaseOrder/settlement/page', params) },
	/** 集采采销一体-结算端筛选项（供应商/客户/审核人 code-name） */
	cpSettlementSalePurchaseOrderFilterOptions: () => { return post('/cp/salePurchaseOrder/settlement/filterOptions', {}) },
	cpSettlementSalePurchaseOrderDetail: (params) => { return post('/cp/salePurchaseOrder/settlement/detail', params) },
	/** 集采采销一体-结算端操作日志（按 BMS 业务单号） */
	cpSettlementSalePurchaseOrderOperateLog: (params) => { return post('/cp/salePurchaseOrder/settlement/operateLog', params) },
	cpSettlementSalePurchaseOrderPaymentRecords: (params) => { return post('/cp/salePurchaseOrder/settlement/paymentRecords', params) },
	cpSettlementSalePurchaseOrderExport: (params, config) => { return post('/cp/salePurchaseOrder/settlement/export', params, config) },
	cpSettlementSalePurchaseOrderImport: (params, config) => {
		return post('/cp/salePurchaseOrder/settlement/import', params, {
			headers: { "Content-Type": "multipart/form-data" }, ...config
		})
	},
	cpSettlementSalePurchaseOrderImportTemplate: () => { return get('/cp/salePurchaseOrder/settlement/importTemplate', null, { responseType: 'blob' }) },
	/** 集采采销一体-结算端客户回款维护 */
	cpSettlementSalePurchaseOrderCustomerPayment: (params) => { return post('/cp/salePurchaseOrder/settlement/customerPayment', params) },
	/** 集采采销一体-结算端销售合同上传（多采购单一份合同） */
	cpSettlementUploadSalesContract: (params) => { return post('/cp/salePurchaseOrder/settlement/uploadSalesContract', params) },
	/** 集采采销一体-结算端客户签收单上传（多采购单一份签收单） */
	cpSettlementUploadCustomerSign: (params) => { return post('/cp/salePurchaseOrder/settlement/uploadCustomerSign', params) },
	/** 集采采销一体-结算端生成合同模版（异步任务） */
	cpSettlementGenerateContractTemplate: (params) => { return post('/cp/salePurchaseOrder/settlement/generateContractTemplate', params) },
	/** 集采采销一体-结算端上传合同文件校验 */
	cpSettlementCheckUploadContract: (params) => { return post('/cp/salePurchaseOrder/settlement/checkUploadContract', params) },
	/** 集采采销一体-结算端批量登记合同 */
	cpSettlementBatchRegisterContract: (params) => { return post('/cp/salePurchaseOrder/settlement/registerContractBatch', params) },
	/** 集采采销一体-供应商门户订单 */
	cpSupplierSalePurchaseOrderPage: (params) => { return post('/cp/salePurchaseOrder/supplier/page', params) },
	cpSupplierSalePurchaseOrderExport: (params, config) => { return post('/cp/salePurchaseOrder/supplier/export', params, config) },
	cpSupplierSalePurchaseOrderDetail: (params) => { return post('/cp/salePurchaseOrder/supplier/detail', params) },
	/** 集采采销一体-供应商端操作日志（按 BMS 业务单号，带供应商隔离） */
	cpSupplierSalePurchaseOrderOperateLog: (params) => { return post('/cp/salePurchaseOrder/supplier/operateLog', params) },
	cpSupplierSalePurchaseOrderPaymentRecords: (params) => { return post('/cp/salePurchaseOrder/supplier/paymentRecords', params) },
	cpSupplierSalePurchaseOrderItemsExport: (params, config) => { return post('/cp/salePurchaseOrder/supplier/items/export', params, config) },
	cpSupplierSalePurchaseOrderRegisterContract: (params) => { return post('/cp/salePurchaseOrder/supplier/registerContract', params) },
	cpSupplierSalePurchaseOrderRegisterSign: (params) => { return post('/cp/salePurchaseOrder/supplier/registerSign', params) },
	cpSupplierSalePurchaseOrderRegisterInvoice: (params) => { return post('/cp/salePurchaseOrder/supplier/registerInvoice', params) },
	cpSupplierSalePurchaseOrderRegisterInvoicePreview: (params) => { return post('/cp/salePurchaseOrder/supplier/registerInvoice/preview', params) },
	cpSupplierSalePurchaseOrderRegisterInvoiceBatch: (params) => { return post('/cp/salePurchaseOrder/supplier/registerInvoice/batch', params) },
	/** 集采发票-结算端 */
	cpSettlementInvoicePage: (params) => { return post('/cp/invoice/settlement/page', params) },
	cpSettlementInvoiceOperateLog: (params) => { return post('/cp/invoice/settlement/operateLog', params) },
	cpSettlementInvoiceDetail: (params) => { return post('/cp/invoice/settlement/detail', params) },
	cpSettlementInvoiceExport: (params, config) => { return post('/cp/invoice/settlement/export', params, config) },
	/** 集采销项台账（金税渠道60）分页；调用处：cpSalesInvoiceLedger */
	cpSalesInvoicePage: (params) => { return post('/cp/salesInvoice/page', params) },
	/** 集采销项台账详情；调用处：cpSalesInvoiceLedger */
	cpSalesInvoiceDetail: (params) => { return post('/cp/salesInvoice/detail', params) },
	/** 集采销项台账销购方下拉；调用处：cpSalesInvoiceLedger */
	cpSalesInvoicePartyOptions: (params) => { return post('/cp/salesInvoice/partyOptions', params) },
	/** 集采销项台账重新获取；调用处：cpSalesInvoiceLedger */
	cpSalesInvoiceReacquire: (params) => { return post('/cp/salesInvoice/reacquire', params) },
	/** 集采销项台账导出；调用处：cpSalesInvoiceLedger */
	cpSalesInvoiceExport: (params, config) => { return post('/cp/salesInvoice/export', params, config) },
	/** 集采回款台账分页；调用处：cpReceiptLedger */
	cpReceiptPage: (params) => { return post('/cp/receipt/page', params) },
	/** 集采回款台账详情；调用处：cpReceiptLedger */
	cpReceiptDetail: (params) => { return post('/cp/receipt/detail', params) },
	/** 集采回款台账导出；调用处：cpReceiptLedger */
	cpReceiptExport: (params, config) => { return post('/cp/receipt/export', params, config) },
	cpReceiptMatchCandidates: (params) => { return post('/cp/receipt/match/candidates', params) },
	cpReceiptMatch: (params) => { return post('/cp/receipt/match', params) },
	cpReceiptRevokeMatch: (params) => { return post('/cp/receipt/match/revoke', params) },
	/** 集采回款认领客编；调用处：cpReceiptLedger */
	cpReceiptClaim: (params) => { return post('/cp/receipt/claim', params) },
	/** 集采回款生成凭证；调用处：cpReceiptLedger */
	cpReceiptGenerateVoucher: (params) => { return post('/cp/receipt/voucher/generate', params) },
	/** 集采回款冲销凭证；调用处：cpReceiptLedger */
	cpReceiptCancelVoucher: (params) => { return post('/cp/receipt/voucher/cancel', params) },
	cpReceiptReturnGs: (params) => { return post('/cp/receipt/returnGs', params) },
	/** 集采发票-供应商门户 */
	cpSupplierInvoicePage: (params) => { return post('/cp/invoice/supplier/page', params) },
	cpSupplierInvoiceOperateLog: (params) => { return post('/cp/invoice/supplier/operateLog', params) },
	cpSupplierInvoiceDetail: (params) => { return post('/cp/invoice/supplier/detail', params) },
	cpSupplierInvoiceExport: (params, config) => { return post('/cp/invoice/supplier/export', params, config) },

	/** 集采汇总付款台账-分页查询 */
	cpPaymentPage: (params, config) => { return post('/cp/payment/page', params, config) },
	/** 集采汇总付款台账-详情 */
	cpPaymentDetail: (params, config) => { return get('/cp/payment/detail/' + ((params && params.paymentNo) || ''), {}, config) },
	/** 集采汇总付款台账-保存（新增提交，整单事务保存） */
	cpPaymentCreate: (params, config) => { return post('/cp/payment/create', params, config) },
	/** 集采汇总付款台账-刷新供应商新增付款锁（先释放旧锁，再申请新锁） */
	cpPaymentRefreshCreateLock: (params, config) => { return post('/cp/payment/refreshCreateLock', params, config) },
	cpPaymentAcquireEditLock: (params, config) => { return post('/cp/payment/acquireEditLock', params, config) },
	cpPaymentReleaseSupplierLock: (params, config) => { return post('/cp/payment/releaseSupplierLock', params, config) },
	/** 集采汇总付款台账-编辑 */
	cpPaymentEdit: (params, config) => { return post('/cp/payment/edit', params, config) },
	/** 集采汇总付款台账-确认 */
	cpPaymentConfirm: (params, config) => { return post('/cp/payment/confirm', params, config) },
	/** 集采汇总付款台账-删除 */
	cpPaymentDelete: (params, config) => { return post('/cp/payment/delete', params, config) },
	/** 集采汇总付款台账-提交 OA（jsfs / bankAccount / bankName 传入 OA 报文） */
	cpPaymentSubmitOA: (params, config) => { return post('/cp/payment/submitOA', params, config) },
	/** 集采汇总付款台账-生成合约预付明细 */
	cpPaymentGenerateContractPrepayDetails: (params, config) => { return post('/cp/payment/generateContractPrepayDetails', params, config) },
	/** 集采汇总付款台账-批量导入（Excel） */
	cpPaymentBatchImport: (params, config) => { return post('/cp/payment/batchImport', params, config) },
	/** 集采汇总付款台账-列表导出 */
	cpPaymentExport: (params, config) => { return post('/cp/payment/export', params, config) },
	/** 集采汇总付款台账-待付明细导出（全量待付金额大于 0） */
	cpPaymentExportUnpaidDetail: (params, config) => { return post('/cp/payment/exportUnpaidDetail', params, config) },
	/** 集采汇总付款台账-导入支付结果（Excel） */
	cpPaymentImportResult: (params, config) => { return post('/cp/payment/importResult', params, config) },
	/** 集采汇总付款：批量上传回执（multipart files，后端上传 OSS 后异步 AI 识别匹配） */
	cpPaymentBatchUploadReceipt: (params, config) => { return post('/cp/payment/batchUploadReceipt', params, config) },
	/** 集采汇总付款台账-下载导入模板 */
	cpPaymentDownloadTemplate: (params, config) => { return get('/cp/payment/downloadTemplate', params, config) },
	/** 集采汇总付款台账-归集明细 */
	cpPaymentCollectDetails: (params, config) => { return post('/cp/payment/collectDetails', params, config) },
	/** 集采汇总付款台账-查询可关联明细 */
	cpPaymentQueryAvailableDetails: (params, config) => { return post('/cp/payment/queryAvailableDetails', params, config) },
	/** 集采预付单台账 */
	cpPrepayPage: (params) => { return post('/cp/prepay/page', params) },
	cpPrepayDetail: (prepayNo) => { return get('/cp/prepay/detail/' + prepayNo) },
	cpPrepayExport: (params, config) => { return post('/cp/prepay/export', params, config) },
	cpPrepayQueryVerifiableDetails: (params) => { return post('/cp/prepay/queryVerifiableDetails', params) },
	cpPrepayBatchVerify: (params) => { return post('/cp/prepay/batchVerify', params) },
	/** 集采进项台账 — 审核/凭证/抵扣 */
	cpInvoiceAudit: (params) => { return post('/cp/invoice/input/audit', params) }, // 优先传 invoiceGroupNos，兼容 invoiceIds
	cpInvoiceRevokeAudit: (params) => { return post('/cp/invoice/input/revokeAudit', params) },
	cpInvoiceGenerateVoucherPreview: (params) => { return post('/cp/invoice/input/generateVoucher/preview', params) },
	cpInvoiceGenerateVoucherSubmit: (params) => { return post('/cp/invoice/input/generateVoucher/submit', params) },
	cpInvoiceGenerateVoucher: (params) => { return post('/cp/invoice/input/generateVoucher', params) },
	cpInvoiceReverseVoucher: (params) => { return post('/cp/invoice/input/reverseVoucher', params) },
	cpInvoiceDeduct: (params) => { return post('/cp/invoice/input/deduct', params) },
	/** 集采进项台账 — 批量下载发票影像 ZIP */
	cpInvoiceZipDown: (params) => { return post('/cp/invoice/input/zipDown', params, { responseType: 'blob' }) },
}
